/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SelectOrgRouteImport } from './routes/select-org'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as DevVisualFixtureRouteImport } from './routes/dev/visual-fixture'
import { Route as AuthVerifyEmailRouteImport } from './routes/auth/verify-email'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthenticatedTestProgramRouteImport } from './routes/_authenticated/test-program'
import { Route as AuthenticatedTestActivityRouteImport } from './routes/_authenticated/test-activity'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedNoticesRouteImport } from './routes/_authenticated/notices'
import { Route as AuthenticatedMfaPromptRouteImport } from './routes/_authenticated/mfa-prompt'
import { Route as AuthenticatedInvitesRouteImport } from './routes/_authenticated/invites'
import { Route as AuthenticatedCategoricalStandardsRouteImport } from './routes/_authenticated/categorical-standards'
import { Route as AuthenticatedCatalogRouteImport } from './routes/_authenticated/catalog'
import { Route as AuthenticatedAcceptInviteRouteImport } from './routes/_authenticated/accept-invite'
import { Route as AuthenticatedTestersIndexRouteImport } from './routes/_authenticated/testers/index'
import { Route as AuthenticatedTestProgramIndexRouteImport } from './routes/_authenticated/test-program/index'
import { Route as AuthenticatedTestActivityIndexRouteImport } from './routes/_authenticated/test-activity/index'
import { Route as AuthenticatedTemporaryDevicesIndexRouteImport } from './routes/_authenticated/temporary-devices/index'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings.index'
import { Route as AuthenticatedSchedulesIndexRouteImport } from './routes/_authenticated/schedules/index'
import { Route as AuthenticatedSamsIndexRouteImport } from './routes/_authenticated/sams/index'
import { Route as AuthenticatedSamplingEventsIndexRouteImport } from './routes/_authenticated/sampling-events/index'
import { Route as AuthenticatedSampleResultsIndexRouteImport } from './routes/_authenticated/sample-results/index'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports/index'
import { Route as AuthenticatedPermitsIndexRouteImport } from './routes/_authenticated/permits/index'
import { Route as AuthenticatedParametersIndexRouteImport } from './routes/_authenticated/parameters/index'
import { Route as AuthenticatedNoticesIndexRouteImport } from './routes/_authenticated/notices/index'
import { Route as AuthenticatedMonitoringLocationsIndexRouteImport } from './routes/_authenticated/monitoring-locations/index'
import { Route as AuthenticatedMonitoringGapsIndexRouteImport } from './routes/_authenticated/monitoring-gaps/index'
import { Route as AuthenticatedMessagesIndexRouteImport } from './routes/_authenticated/messages/index'
import { Route as AuthenticatedLabsIndexRouteImport } from './routes/_authenticated/labs/index'
import { Route as AuthenticatedFacilitiesIndexRouteImport } from './routes/_authenticated/facilities/index'
import { Route as AuthenticatedExceedancesIndexRouteImport } from './routes/_authenticated/exceedances/index'
import { Route as AuthenticatedDocumentsIndexRouteImport } from './routes/_authenticated/documents/index'
import { Route as AuthenticatedDeviceInstallationsIndexRouteImport } from './routes/_authenticated/device-installations/index'
import { Route as AuthenticatedBulkEditsIndexRouteImport } from './routes/_authenticated/bulk-edits/index'
import { Route as AuthenticatedAccountsIndexRouteImport } from './routes/_authenticated/accounts/index'
import { Route as AuthenticatedTestEntryNewRouteImport } from './routes/_authenticated/test-entry/new'
import { Route as AuthenticatedTemporaryDevicesNewRouteImport } from './routes/_authenticated/temporary-devices/new'
import { Route as AuthenticatedSettingsMfaRouteImport } from './routes/_authenticated/settings/mfa'
import { Route as AuthenticatedSchedulesNewRouteImport } from './routes/_authenticated/schedules/new'
import { Route as AuthenticatedSchedulesScheduleIdRouteImport } from './routes/_authenticated/schedules/$scheduleId'
import { Route as AuthenticatedSamplingCalendarRouteImport } from './routes/_authenticated/sampling/calendar'
import { Route as AuthenticatedSamplingEventsNewRouteImport } from './routes/_authenticated/sampling-events/new'
import { Route as AuthenticatedReportsNewRouteImport } from './routes/_authenticated/reports/new'
import { Route as AuthenticatedPermitsNewRouteImport } from './routes/_authenticated/permits/new'
import { Route as AuthenticatedParametersNewRouteImport } from './routes/_authenticated/parameters/new'
import { Route as AuthenticatedOrgSettingsRouteImport } from './routes/_authenticated/org/settings'
import { Route as AuthenticatedMonitoringLocationsNewRouteImport } from './routes/_authenticated/monitoring-locations/new'
import { Route as AuthenticatedLabsNewRouteImport } from './routes/_authenticated/labs/new'
import { Route as AuthenticatedLabsDefaultsRouteImport } from './routes/_authenticated/labs/defaults'
import { Route as AuthenticatedFacilitiesNewRouteImport } from './routes/_authenticated/facilities/new'
import { Route as AuthenticatedCatalogShutoffValvesRouteImport } from './routes/_authenticated/catalog/shutoff-valves'
import { Route as AuthenticatedCatalogLookupRouteImport } from './routes/_authenticated/catalog/lookup'
import { Route as AuthenticatedCatalogDetectorMetersRouteImport } from './routes/_authenticated/catalog/detector-meters'
import { Route as AuthenticatedBulkEditsNewRouteImport } from './routes/_authenticated/bulk-edits/new'
import { Route as AuthenticatedAccountsNewRouteImport } from './routes/_authenticated/accounts/new'
import { Route as AuthenticatedTestingCompaniesIdIndexRouteImport } from './routes/_authenticated/testing-companies/$id/index'
import { Route as AuthenticatedTestersIdIndexRouteImport } from './routes/_authenticated/testers/$id/index'
import { Route as AuthenticatedTestKitsIdIndexRouteImport } from './routes/_authenticated/test-kits/$id/index'
import { Route as AuthenticatedTestEntryAssignmentIdIndexRouteImport } from './routes/_authenticated/test-entry/$assignmentId/index'
import { Route as AuthenticatedTemporaryDevicesIdIndexRouteImport } from './routes/_authenticated/temporary-devices/$id/index'
import { Route as AuthenticatedTasksIdIndexRouteImport } from './routes/_authenticated/tasks/$id/index'
import { Route as AuthenticatedSamplingEventsEventIdIndexRouteImport } from './routes/_authenticated/sampling-events/$eventId/index'
import { Route as AuthenticatedSampleResultsResultIdIndexRouteImport } from './routes/_authenticated/sample-results/$resultId/index'
import { Route as AuthenticatedReportsIdIndexRouteImport } from './routes/_authenticated/reports/$id/index'
import { Route as AuthenticatedPermitsPermitIdIndexRouteImport } from './routes/_authenticated/permits/$permitId/index'
import { Route as AuthenticatedParametersParameterIdIndexRouteImport } from './routes/_authenticated/parameters/$parameterId/index'
import { Route as AuthenticatedOrgSettingsIndexRouteImport } from './routes/_authenticated/org/settings/index'
import { Route as AuthenticatedNoticesNewIndexRouteImport } from './routes/_authenticated/notices/new/index'
import { Route as AuthenticatedNoticesIdIndexRouteImport } from './routes/_authenticated/notices/$id/index'
import { Route as AuthenticatedMonitoringLocationsLocationIdIndexRouteImport } from './routes/_authenticated/monitoring-locations/$locationId/index'
import { Route as AuthenticatedLabsLabIdIndexRouteImport } from './routes/_authenticated/labs/$labId/index'
import { Route as AuthenticatedFacilitiesFacilityIdIndexRouteImport } from './routes/_authenticated/facilities/$facilityId/index'
import { Route as AuthenticatedDeviceInstallationsIdIndexRouteImport } from './routes/_authenticated/device-installations/$id/index'
import { Route as AuthenticatedCatalogSpecialNoticesIndexRouteImport } from './routes/_authenticated/catalog/special-notices.index'
import { Route as AuthenticatedCatalogAssembliesIndexRouteImport } from './routes/_authenticated/catalog/assemblies.index'
import { Route as AuthenticatedBulkEditsRunIdIndexRouteImport } from './routes/_authenticated/bulk-edits/$runId/index'
import { Route as AuthenticatedBackflowOutOfComplianceIndexRouteImport } from './routes/_authenticated/backflow/out-of-compliance/index'
import { Route as AuthenticatedAccountsIdIndexRouteImport } from './routes/_authenticated/accounts/$id/index'
import { Route as AuthenticatedTestersAccessRequestsCompanyIdRouteImport } from './routes/_authenticated/testers/access-requests.$companyId'
import { Route as AuthenticatedTestProgramTemplatesNewRouteImport } from './routes/_authenticated/test-program/templates/new'
import { Route as AuthenticatedTestProgramSchedulesNewRouteImport } from './routes/_authenticated/test-program/schedules/new'
import { Route as AuthenticatedTestKitsIdEditRouteImport } from './routes/_authenticated/test-kits/$id/edit'
import { Route as AuthenticatedTestActivityAssignmentsNewRouteImport } from './routes/_authenticated/test-activity/assignments/new'
import { Route as AuthenticatedTemporaryDevicesIdEditRouteImport } from './routes/_authenticated/temporary-devices/$id/edit'
import { Route as AuthenticatedTasksIdEditRouteImport } from './routes/_authenticated/tasks/$id/edit'
import { Route as AuthenticatedReportsDashboardsNewRouteImport } from './routes/_authenticated/reports/dashboards/new'
import { Route as AuthenticatedReportsIdEditRouteImport } from './routes/_authenticated/reports/$id/edit'
import { Route as AuthenticatedPermitsPermitIdParametersRouteImport } from './routes/_authenticated/permits/$permitId/parameters'
import { Route as AuthenticatedPermitsPermitIdEditRouteImport } from './routes/_authenticated/permits/$permitId/edit'
import { Route as AuthenticatedParametersParameterIdEditRouteImport } from './routes/_authenticated/parameters/$parameterId/edit'
import { Route as AuthenticatedNoticesRulesNewRouteImport } from './routes/_authenticated/notices/rules/new'
import { Route as AuthenticatedNoticesIdEditRouteImport } from './routes/_authenticated/notices/$id/edit'
import { Route as AuthenticatedMonitoringLocationsLocationIdEditRouteImport } from './routes/_authenticated/monitoring-locations/$locationId/edit'
import { Route as AuthenticatedCatalogSpecialNoticesIdRouteImport } from './routes/_authenticated/catalog/special-notices.$id'
import { Route as AuthenticatedCatalogManufacturersIdRouteImport } from './routes/_authenticated/catalog/manufacturers.$id'
import { Route as AuthenticatedCatalogAssembliesIdRouteImport } from './routes/_authenticated/catalog/assemblies.$id'
import { Route as AuthenticatedTestProgramTemplatesIdIndexRouteImport } from './routes/_authenticated/test-program/templates/$id/index'
import { Route as AuthenticatedTestActivityViolationsIdIndexRouteImport } from './routes/_authenticated/test-activity/violations/$id/index'
import { Route as AuthenticatedTestActivitySubmissionsIdIndexRouteImport } from './routes/_authenticated/test-activity/submissions/$id/index'
import { Route as AuthenticatedTestActivityChangeRequestsSetIdIndexRouteImport } from './routes/_authenticated/test-activity/change-requests/$setId/index'
import { Route as AuthenticatedTestActivityAssignmentsIdIndexRouteImport } from './routes/_authenticated/test-activity/assignments/$id/index'
import { Route as AuthenticatedReportsDashboardsIdIndexRouteImport } from './routes/_authenticated/reports/dashboards/$id/index'
import { Route as AuthenticatedNoticesTemplatesIdIndexRouteImport } from './routes/_authenticated/notices/templates/$id/index'
import { Route as AuthenticatedNoticesRulesLadderIdIndexRouteImport } from './routes/_authenticated/notices/rules/$ladderId/index'
import { Route as AuthenticatedTestProgramTemplatesIdBuilderRouteImport } from './routes/_authenticated/test-program/templates/$id/builder'
import { Route as AuthenticatedTestProgramSchedulesIdEditRouteImport } from './routes/_authenticated/test-program/schedules/$id/edit'
import { Route as AuthenticatedOrgSettingsMembersMemberIdRouteImport } from './routes/_authenticated/org/settings/members/$memberId'
import { Route as AuthenticatedOrgSettingsGroupsNewRouteImport } from './routes/_authenticated/org/settings/groups/new'
import { Route as AuthenticatedOrgSettingsGroupsGroupIdIndexRouteImport } from './routes/_authenticated/org/settings/groups/$groupId/index'
import { Route as AuthenticatedOrgSettingsReportFormsIdEditRouteImport } from './routes/_authenticated/org/settings/report-forms/$id/edit'
import { Route as AuthenticatedOrgSettingsGroupsGroupIdEditRouteImport } from './routes/_authenticated/org/settings/groups/$groupId/edit'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SelectOrgRoute = SelectOrgRouteImport.update({
  id: '/select-org',
  path: '/select-org',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const DevVisualFixtureRoute = DevVisualFixtureRouteImport.update({
  id: '/dev/visual-fixture',
  path: '/dev/visual-fixture',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/auth/verify-email',
  path: '/auth/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTestProgramRoute =
  AuthenticatedTestProgramRouteImport.update({
    id: '/test-program',
    path: '/test-program',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTestActivityRoute =
  AuthenticatedTestActivityRouteImport.update({
    id: '/test-activity',
    path: '/test-activity',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNoticesRoute = AuthenticatedNoticesRouteImport.update({
  id: '/notices',
  path: '/notices',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMfaPromptRoute = AuthenticatedMfaPromptRouteImport.update({
  id: '/mfa-prompt',
  path: '/mfa-prompt',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInvitesRoute = AuthenticatedInvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCategoricalStandardsRoute =
  AuthenticatedCategoricalStandardsRouteImport.update({
    id: '/categorical-standards',
    path: '/categorical-standards',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCatalogRoute = AuthenticatedCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAcceptInviteRoute =
  AuthenticatedAcceptInviteRouteImport.update({
    id: '/accept-invite',
    path: '/accept-invite',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTestersIndexRoute =
  AuthenticatedTestersIndexRouteImport.update({
    id: '/testers/',
    path: '/testers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTestProgramIndexRoute =
  AuthenticatedTestProgramIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTestProgramRoute,
  } as any)
const AuthenticatedTestActivityIndexRoute =
  AuthenticatedTestActivityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTestActivityRoute,
  } as any)
const AuthenticatedTemporaryDevicesIndexRoute =
  AuthenticatedTemporaryDevicesIndexRouteImport.update({
    id: '/temporary-devices/',
    path: '/temporary-devices/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSchedulesIndexRoute =
  AuthenticatedSchedulesIndexRouteImport.update({
    id: '/schedules/',
    path: '/schedules/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSamsIndexRoute = AuthenticatedSamsIndexRouteImport.update({
  id: '/sams/',
  path: '/sams/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSamplingEventsIndexRoute =
  AuthenticatedSamplingEventsIndexRouteImport.update({
    id: '/sampling-events/',
    path: '/sampling-events/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSampleResultsIndexRoute =
  AuthenticatedSampleResultsIndexRouteImport.update({
    id: '/sample-results/',
    path: '/sample-results/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPermitsIndexRoute =
  AuthenticatedPermitsIndexRouteImport.update({
    id: '/permits/',
    path: '/permits/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedParametersIndexRoute =
  AuthenticatedParametersIndexRouteImport.update({
    id: '/parameters/',
    path: '/parameters/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNoticesIndexRoute =
  AuthenticatedNoticesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedNoticesRoute,
  } as any)
const AuthenticatedMonitoringLocationsIndexRoute =
  AuthenticatedMonitoringLocationsIndexRouteImport.update({
    id: '/monitoring-locations/',
    path: '/monitoring-locations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMonitoringGapsIndexRoute =
  AuthenticatedMonitoringGapsIndexRouteImport.update({
    id: '/monitoring-gaps/',
    path: '/monitoring-gaps/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMessagesIndexRoute =
  AuthenticatedMessagesIndexRouteImport.update({
    id: '/messages/',
    path: '/messages/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLabsIndexRoute = AuthenticatedLabsIndexRouteImport.update({
  id: '/labs/',
  path: '/labs/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFacilitiesIndexRoute =
  AuthenticatedFacilitiesIndexRouteImport.update({
    id: '/facilities/',
    path: '/facilities/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExceedancesIndexRoute =
  AuthenticatedExceedancesIndexRouteImport.update({
    id: '/exceedances/',
    path: '/exceedances/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDocumentsIndexRoute =
  AuthenticatedDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDeviceInstallationsIndexRoute =
  AuthenticatedDeviceInstallationsIndexRouteImport.update({
    id: '/device-installations/',
    path: '/device-installations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBulkEditsIndexRoute =
  AuthenticatedBulkEditsIndexRouteImport.update({
    id: '/bulk-edits/',
    path: '/bulk-edits/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountsIndexRoute =
  AuthenticatedAccountsIndexRouteImport.update({
    id: '/accounts/',
    path: '/accounts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTestEntryNewRoute =
  AuthenticatedTestEntryNewRouteImport.update({
    id: '/test-entry/new',
    path: '/test-entry/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTemporaryDevicesNewRoute =
  AuthenticatedTemporaryDevicesNewRouteImport.update({
    id: '/temporary-devices/new',
    path: '/temporary-devices/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsMfaRoute =
  AuthenticatedSettingsMfaRouteImport.update({
    id: '/mfa',
    path: '/mfa',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSchedulesNewRoute =
  AuthenticatedSchedulesNewRouteImport.update({
    id: '/schedules/new',
    path: '/schedules/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSchedulesScheduleIdRoute =
  AuthenticatedSchedulesScheduleIdRouteImport.update({
    id: '/schedules/$scheduleId',
    path: '/schedules/$scheduleId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSamplingCalendarRoute =
  AuthenticatedSamplingCalendarRouteImport.update({
    id: '/sampling/calendar',
    path: '/sampling/calendar',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSamplingEventsNewRoute =
  AuthenticatedSamplingEventsNewRouteImport.update({
    id: '/sampling-events/new',
    path: '/sampling-events/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsNewRoute = AuthenticatedReportsNewRouteImport.update({
  id: '/reports/new',
  path: '/reports/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPermitsNewRoute = AuthenticatedPermitsNewRouteImport.update({
  id: '/permits/new',
  path: '/permits/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedParametersNewRoute =
  AuthenticatedParametersNewRouteImport.update({
    id: '/parameters/new',
    path: '/parameters/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgSettingsRoute =
  AuthenticatedOrgSettingsRouteImport.update({
    id: '/org/settings',
    path: '/org/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMonitoringLocationsNewRoute =
  AuthenticatedMonitoringLocationsNewRouteImport.update({
    id: '/monitoring-locations/new',
    path: '/monitoring-locations/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLabsNewRoute = AuthenticatedLabsNewRouteImport.update({
  id: '/labs/new',
  path: '/labs/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLabsDefaultsRoute =
  AuthenticatedLabsDefaultsRouteImport.update({
    id: '/labs/defaults',
    path: '/labs/defaults',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFacilitiesNewRoute =
  AuthenticatedFacilitiesNewRouteImport.update({
    id: '/facilities/new',
    path: '/facilities/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCatalogShutoffValvesRoute =
  AuthenticatedCatalogShutoffValvesRouteImport.update({
    id: '/shutoff-valves',
    path: '/shutoff-valves',
    getParentRoute: () => AuthenticatedCatalogRoute,
  } as any)
const AuthenticatedCatalogLookupRoute =
  AuthenticatedCatalogLookupRouteImport.update({
    id: '/lookup',
    path: '/lookup',
    getParentRoute: () => AuthenticatedCatalogRoute,
  } as any)
const AuthenticatedCatalogDetectorMetersRoute =
  AuthenticatedCatalogDetectorMetersRouteImport.update({
    id: '/detector-meters',
    path: '/detector-meters',
    getParentRoute: () => AuthenticatedCatalogRoute,
  } as any)
const AuthenticatedBulkEditsNewRoute =
  AuthenticatedBulkEditsNewRouteImport.update({
    id: '/bulk-edits/new',
    path: '/bulk-edits/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountsNewRoute =
  AuthenticatedAccountsNewRouteImport.update({
    id: '/accounts/new',
    path: '/accounts/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTestingCompaniesIdIndexRoute =
  AuthenticatedTestingCompaniesIdIndexRouteImport.update({
    id: '/testing-companies/$id/',
    path: '/testing-companies/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTestersIdIndexRoute =
  AuthenticatedTestersIdIndexRouteImport.update({
    id: '/testers/$id/',
    path: '/testers/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTestKitsIdIndexRoute =
  AuthenticatedTestKitsIdIndexRouteImport.update({
    id: '/test-kits/$id/',
    path: '/test-kits/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTestEntryAssignmentIdIndexRoute =
  AuthenticatedTestEntryAssignmentIdIndexRouteImport.update({
    id: '/test-entry/$assignmentId/',
    path: '/test-entry/$assignmentId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTemporaryDevicesIdIndexRoute =
  AuthenticatedTemporaryDevicesIdIndexRouteImport.update({
    id: '/temporary-devices/$id/',
    path: '/temporary-devices/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksIdIndexRoute =
  AuthenticatedTasksIdIndexRouteImport.update({
    id: '/tasks/$id/',
    path: '/tasks/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSamplingEventsEventIdIndexRoute =
  AuthenticatedSamplingEventsEventIdIndexRouteImport.update({
    id: '/sampling-events/$eventId/',
    path: '/sampling-events/$eventId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSampleResultsResultIdIndexRoute =
  AuthenticatedSampleResultsResultIdIndexRouteImport.update({
    id: '/sample-results/$resultId/',
    path: '/sample-results/$resultId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsIdIndexRoute =
  AuthenticatedReportsIdIndexRouteImport.update({
    id: '/reports/$id/',
    path: '/reports/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPermitsPermitIdIndexRoute =
  AuthenticatedPermitsPermitIdIndexRouteImport.update({
    id: '/permits/$permitId/',
    path: '/permits/$permitId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedParametersParameterIdIndexRoute =
  AuthenticatedParametersParameterIdIndexRouteImport.update({
    id: '/parameters/$parameterId/',
    path: '/parameters/$parameterId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgSettingsIndexRoute =
  AuthenticatedOrgSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgSettingsRoute,
  } as any)
const AuthenticatedNoticesNewIndexRoute =
  AuthenticatedNoticesNewIndexRouteImport.update({
    id: '/new/',
    path: '/new/',
    getParentRoute: () => AuthenticatedNoticesRoute,
  } as any)
const AuthenticatedNoticesIdIndexRoute =
  AuthenticatedNoticesIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => AuthenticatedNoticesRoute,
  } as any)
const AuthenticatedMonitoringLocationsLocationIdIndexRoute =
  AuthenticatedMonitoringLocationsLocationIdIndexRouteImport.update({
    id: '/monitoring-locations/$locationId/',
    path: '/monitoring-locations/$locationId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLabsLabIdIndexRoute =
  AuthenticatedLabsLabIdIndexRouteImport.update({
    id: '/labs/$labId/',
    path: '/labs/$labId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFacilitiesFacilityIdIndexRoute =
  AuthenticatedFacilitiesFacilityIdIndexRouteImport.update({
    id: '/facilities/$facilityId/',
    path: '/facilities/$facilityId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDeviceInstallationsIdIndexRoute =
  AuthenticatedDeviceInstallationsIdIndexRouteImport.update({
    id: '/device-installations/$id/',
    path: '/device-installations/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCatalogSpecialNoticesIndexRoute =
  AuthenticatedCatalogSpecialNoticesIndexRouteImport.update({
    id: '/special-notices/',
    path: '/special-notices/',
    getParentRoute: () => AuthenticatedCatalogRoute,
  } as any)
const AuthenticatedCatalogAssembliesIndexRoute =
  AuthenticatedCatalogAssembliesIndexRouteImport.update({
    id: '/assemblies/',
    path: '/assemblies/',
    getParentRoute: () => AuthenticatedCatalogRoute,
  } as any)
const AuthenticatedBulkEditsRunIdIndexRoute =
  AuthenticatedBulkEditsRunIdIndexRouteImport.update({
    id: '/bulk-edits/$runId/',
    path: '/bulk-edits/$runId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBackflowOutOfComplianceIndexRoute =
  AuthenticatedBackflowOutOfComplianceIndexRouteImport.update({
    id: '/backflow/out-of-compliance/',
    path: '/backflow/out-of-compliance/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountsIdIndexRoute =
  AuthenticatedAccountsIdIndexRouteImport.update({
    id: '/accounts/$id/',
    path: '/accounts/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTestersAccessRequestsCompanyIdRoute =
  AuthenticatedTestersAccessRequestsCompanyIdRouteImport.update({
    id: '/testers/access-requests/$companyId',
    path: '/testers/access-requests/$companyId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTestProgramTemplatesNewRoute =
  AuthenticatedTestProgramTemplatesNewRouteImport.update({
    id: '/templates/new',
    path: '/templates/new',
    getParentRoute: () => AuthenticatedTestProgramRoute,
  } as any)
const AuthenticatedTestProgramSchedulesNewRoute =
  AuthenticatedTestProgramSchedulesNewRouteImport.update({
    id: '/schedules/new',
    path: '/schedules/new',
    getParentRoute: () => AuthenticatedTestProgramRoute,
  } as any)
const AuthenticatedTestKitsIdEditRoute =
  AuthenticatedTestKitsIdEditRouteImport.update({
    id: '/test-kits/$id/edit',
    path: '/test-kits/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTestActivityAssignmentsNewRoute =
  AuthenticatedTestActivityAssignmentsNewRouteImport.update({
    id: '/assignments/new',
    path: '/assignments/new',
    getParentRoute: () => AuthenticatedTestActivityRoute,
  } as any)
const AuthenticatedTemporaryDevicesIdEditRoute =
  AuthenticatedTemporaryDevicesIdEditRouteImport.update({
    id: '/temporary-devices/$id/edit',
    path: '/temporary-devices/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksIdEditRoute =
  AuthenticatedTasksIdEditRouteImport.update({
    id: '/tasks/$id/edit',
    path: '/tasks/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsDashboardsNewRoute =
  AuthenticatedReportsDashboardsNewRouteImport.update({
    id: '/reports/dashboards/new',
    path: '/reports/dashboards/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsIdEditRoute =
  AuthenticatedReportsIdEditRouteImport.update({
    id: '/reports/$id/edit',
    path: '/reports/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPermitsPermitIdParametersRoute =
  AuthenticatedPermitsPermitIdParametersRouteImport.update({
    id: '/permits/$permitId/parameters',
    path: '/permits/$permitId/parameters',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPermitsPermitIdEditRoute =
  AuthenticatedPermitsPermitIdEditRouteImport.update({
    id: '/permits/$permitId/edit',
    path: '/permits/$permitId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedParametersParameterIdEditRoute =
  AuthenticatedParametersParameterIdEditRouteImport.update({
    id: '/parameters/$parameterId/edit',
    path: '/parameters/$parameterId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNoticesRulesNewRoute =
  AuthenticatedNoticesRulesNewRouteImport.update({
    id: '/rules/new',
    path: '/rules/new',
    getParentRoute: () => AuthenticatedNoticesRoute,
  } as any)
const AuthenticatedNoticesIdEditRoute =
  AuthenticatedNoticesIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AuthenticatedNoticesRoute,
  } as any)
const AuthenticatedMonitoringLocationsLocationIdEditRoute =
  AuthenticatedMonitoringLocationsLocationIdEditRouteImport.update({
    id: '/monitoring-locations/$locationId/edit',
    path: '/monitoring-locations/$locationId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCatalogSpecialNoticesIdRoute =
  AuthenticatedCatalogSpecialNoticesIdRouteImport.update({
    id: '/special-notices/$id',
    path: '/special-notices/$id',
    getParentRoute: () => AuthenticatedCatalogRoute,
  } as any)
const AuthenticatedCatalogManufacturersIdRoute =
  AuthenticatedCatalogManufacturersIdRouteImport.update({
    id: '/manufacturers/$id',
    path: '/manufacturers/$id',
    getParentRoute: () => AuthenticatedCatalogRoute,
  } as any)
const AuthenticatedCatalogAssembliesIdRoute =
  AuthenticatedCatalogAssembliesIdRouteImport.update({
    id: '/assemblies/$id',
    path: '/assemblies/$id',
    getParentRoute: () => AuthenticatedCatalogRoute,
  } as any)
const AuthenticatedTestProgramTemplatesIdIndexRoute =
  AuthenticatedTestProgramTemplatesIdIndexRouteImport.update({
    id: '/templates/$id/',
    path: '/templates/$id/',
    getParentRoute: () => AuthenticatedTestProgramRoute,
  } as any)
const AuthenticatedTestActivityViolationsIdIndexRoute =
  AuthenticatedTestActivityViolationsIdIndexRouteImport.update({
    id: '/violations/$id/',
    path: '/violations/$id/',
    getParentRoute: () => AuthenticatedTestActivityRoute,
  } as any)
const AuthenticatedTestActivitySubmissionsIdIndexRoute =
  AuthenticatedTestActivitySubmissionsIdIndexRouteImport.update({
    id: '/submissions/$id/',
    path: '/submissions/$id/',
    getParentRoute: () => AuthenticatedTestActivityRoute,
  } as any)
const AuthenticatedTestActivityChangeRequestsSetIdIndexRoute =
  AuthenticatedTestActivityChangeRequestsSetIdIndexRouteImport.update({
    id: '/change-requests/$setId/',
    path: '/change-requests/$setId/',
    getParentRoute: () => AuthenticatedTestActivityRoute,
  } as any)
const AuthenticatedTestActivityAssignmentsIdIndexRoute =
  AuthenticatedTestActivityAssignmentsIdIndexRouteImport.update({
    id: '/assignments/$id/',
    path: '/assignments/$id/',
    getParentRoute: () => AuthenticatedTestActivityRoute,
  } as any)
const AuthenticatedReportsDashboardsIdIndexRoute =
  AuthenticatedReportsDashboardsIdIndexRouteImport.update({
    id: '/reports/dashboards/$id/',
    path: '/reports/dashboards/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNoticesTemplatesIdIndexRoute =
  AuthenticatedNoticesTemplatesIdIndexRouteImport.update({
    id: '/templates/$id/',
    path: '/templates/$id/',
    getParentRoute: () => AuthenticatedNoticesRoute,
  } as any)
const AuthenticatedNoticesRulesLadderIdIndexRoute =
  AuthenticatedNoticesRulesLadderIdIndexRouteImport.update({
    id: '/rules/$ladderId/',
    path: '/rules/$ladderId/',
    getParentRoute: () => AuthenticatedNoticesRoute,
  } as any)
const AuthenticatedTestProgramTemplatesIdBuilderRoute =
  AuthenticatedTestProgramTemplatesIdBuilderRouteImport.update({
    id: '/templates/$id/builder',
    path: '/templates/$id/builder',
    getParentRoute: () => AuthenticatedTestProgramRoute,
  } as any)
const AuthenticatedTestProgramSchedulesIdEditRoute =
  AuthenticatedTestProgramSchedulesIdEditRouteImport.update({
    id: '/schedules/$id/edit',
    path: '/schedules/$id/edit',
    getParentRoute: () => AuthenticatedTestProgramRoute,
  } as any)
const AuthenticatedOrgSettingsMembersMemberIdRoute =
  AuthenticatedOrgSettingsMembersMemberIdRouteImport.update({
    id: '/members/$memberId',
    path: '/members/$memberId',
    getParentRoute: () => AuthenticatedOrgSettingsRoute,
  } as any)
const AuthenticatedOrgSettingsGroupsNewRoute =
  AuthenticatedOrgSettingsGroupsNewRouteImport.update({
    id: '/groups/new',
    path: '/groups/new',
    getParentRoute: () => AuthenticatedOrgSettingsRoute,
  } as any)
const AuthenticatedOrgSettingsGroupsGroupIdIndexRoute =
  AuthenticatedOrgSettingsGroupsGroupIdIndexRouteImport.update({
    id: '/groups/$groupId/',
    path: '/groups/$groupId/',
    getParentRoute: () => AuthenticatedOrgSettingsRoute,
  } as any)
const AuthenticatedOrgSettingsReportFormsIdEditRoute =
  AuthenticatedOrgSettingsReportFormsIdEditRouteImport.update({
    id: '/report-forms/$id/edit',
    path: '/report-forms/$id/edit',
    getParentRoute: () => AuthenticatedOrgSettingsRoute,
  } as any)
const AuthenticatedOrgSettingsGroupsGroupIdEditRoute =
  AuthenticatedOrgSettingsGroupsGroupIdEditRouteImport.update({
    id: '/groups/$groupId/edit',
    path: '/groups/$groupId/edit',
    getParentRoute: () => AuthenticatedOrgSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/select-org': typeof SelectOrgRoute
  '/signup': typeof SignupRoute
  '/accept-invite': typeof AuthenticatedAcceptInviteRoute
  '/catalog': typeof AuthenticatedCatalogRouteWithChildren
  '/categorical-standards': typeof AuthenticatedCategoricalStandardsRoute
  '/invites': typeof AuthenticatedInvitesRoute
  '/mfa-prompt': typeof AuthenticatedMfaPromptRoute
  '/notices': typeof AuthenticatedNoticesRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/test-activity': typeof AuthenticatedTestActivityRouteWithChildren
  '/test-program': typeof AuthenticatedTestProgramRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/dev/visual-fixture': typeof DevVisualFixtureRoute
  '/accounts/new': typeof AuthenticatedAccountsNewRoute
  '/bulk-edits/new': typeof AuthenticatedBulkEditsNewRoute
  '/catalog/detector-meters': typeof AuthenticatedCatalogDetectorMetersRoute
  '/catalog/lookup': typeof AuthenticatedCatalogLookupRoute
  '/catalog/shutoff-valves': typeof AuthenticatedCatalogShutoffValvesRoute
  '/facilities/new': typeof AuthenticatedFacilitiesNewRoute
  '/labs/defaults': typeof AuthenticatedLabsDefaultsRoute
  '/labs/new': typeof AuthenticatedLabsNewRoute
  '/monitoring-locations/new': typeof AuthenticatedMonitoringLocationsNewRoute
  '/org/settings': typeof AuthenticatedOrgSettingsRouteWithChildren
  '/parameters/new': typeof AuthenticatedParametersNewRoute
  '/permits/new': typeof AuthenticatedPermitsNewRoute
  '/reports/new': typeof AuthenticatedReportsNewRoute
  '/sampling-events/new': typeof AuthenticatedSamplingEventsNewRoute
  '/sampling/calendar': typeof AuthenticatedSamplingCalendarRoute
  '/schedules/$scheduleId': typeof AuthenticatedSchedulesScheduleIdRoute
  '/schedules/new': typeof AuthenticatedSchedulesNewRoute
  '/settings/mfa': typeof AuthenticatedSettingsMfaRoute
  '/temporary-devices/new': typeof AuthenticatedTemporaryDevicesNewRoute
  '/test-entry/new': typeof AuthenticatedTestEntryNewRoute
  '/accounts/': typeof AuthenticatedAccountsIndexRoute
  '/bulk-edits/': typeof AuthenticatedBulkEditsIndexRoute
  '/device-installations/': typeof AuthenticatedDeviceInstallationsIndexRoute
  '/documents/': typeof AuthenticatedDocumentsIndexRoute
  '/exceedances/': typeof AuthenticatedExceedancesIndexRoute
  '/facilities/': typeof AuthenticatedFacilitiesIndexRoute
  '/labs/': typeof AuthenticatedLabsIndexRoute
  '/messages/': typeof AuthenticatedMessagesIndexRoute
  '/monitoring-gaps/': typeof AuthenticatedMonitoringGapsIndexRoute
  '/monitoring-locations/': typeof AuthenticatedMonitoringLocationsIndexRoute
  '/notices/': typeof AuthenticatedNoticesIndexRoute
  '/parameters/': typeof AuthenticatedParametersIndexRoute
  '/permits/': typeof AuthenticatedPermitsIndexRoute
  '/reports/': typeof AuthenticatedReportsIndexRoute
  '/sample-results/': typeof AuthenticatedSampleResultsIndexRoute
  '/sampling-events/': typeof AuthenticatedSamplingEventsIndexRoute
  '/sams/': typeof AuthenticatedSamsIndexRoute
  '/schedules/': typeof AuthenticatedSchedulesIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/tasks/': typeof AuthenticatedTasksIndexRoute
  '/temporary-devices/': typeof AuthenticatedTemporaryDevicesIndexRoute
  '/test-activity/': typeof AuthenticatedTestActivityIndexRoute
  '/test-program/': typeof AuthenticatedTestProgramIndexRoute
  '/testers/': typeof AuthenticatedTestersIndexRoute
  '/catalog/assemblies/$id': typeof AuthenticatedCatalogAssembliesIdRoute
  '/catalog/manufacturers/$id': typeof AuthenticatedCatalogManufacturersIdRoute
  '/catalog/special-notices/$id': typeof AuthenticatedCatalogSpecialNoticesIdRoute
  '/monitoring-locations/$locationId/edit': typeof AuthenticatedMonitoringLocationsLocationIdEditRoute
  '/notices/$id/edit': typeof AuthenticatedNoticesIdEditRoute
  '/notices/rules/new': typeof AuthenticatedNoticesRulesNewRoute
  '/parameters/$parameterId/edit': typeof AuthenticatedParametersParameterIdEditRoute
  '/permits/$permitId/edit': typeof AuthenticatedPermitsPermitIdEditRoute
  '/permits/$permitId/parameters': typeof AuthenticatedPermitsPermitIdParametersRoute
  '/reports/$id/edit': typeof AuthenticatedReportsIdEditRoute
  '/reports/dashboards/new': typeof AuthenticatedReportsDashboardsNewRoute
  '/tasks/$id/edit': typeof AuthenticatedTasksIdEditRoute
  '/temporary-devices/$id/edit': typeof AuthenticatedTemporaryDevicesIdEditRoute
  '/test-activity/assignments/new': typeof AuthenticatedTestActivityAssignmentsNewRoute
  '/test-kits/$id/edit': typeof AuthenticatedTestKitsIdEditRoute
  '/test-program/schedules/new': typeof AuthenticatedTestProgramSchedulesNewRoute
  '/test-program/templates/new': typeof AuthenticatedTestProgramTemplatesNewRoute
  '/testers/access-requests/$companyId': typeof AuthenticatedTestersAccessRequestsCompanyIdRoute
  '/accounts/$id/': typeof AuthenticatedAccountsIdIndexRoute
  '/backflow/out-of-compliance/': typeof AuthenticatedBackflowOutOfComplianceIndexRoute
  '/bulk-edits/$runId/': typeof AuthenticatedBulkEditsRunIdIndexRoute
  '/catalog/assemblies/': typeof AuthenticatedCatalogAssembliesIndexRoute
  '/catalog/special-notices/': typeof AuthenticatedCatalogSpecialNoticesIndexRoute
  '/device-installations/$id/': typeof AuthenticatedDeviceInstallationsIdIndexRoute
  '/facilities/$facilityId/': typeof AuthenticatedFacilitiesFacilityIdIndexRoute
  '/labs/$labId/': typeof AuthenticatedLabsLabIdIndexRoute
  '/monitoring-locations/$locationId/': typeof AuthenticatedMonitoringLocationsLocationIdIndexRoute
  '/notices/$id/': typeof AuthenticatedNoticesIdIndexRoute
  '/notices/new/': typeof AuthenticatedNoticesNewIndexRoute
  '/org/settings/': typeof AuthenticatedOrgSettingsIndexRoute
  '/parameters/$parameterId/': typeof AuthenticatedParametersParameterIdIndexRoute
  '/permits/$permitId/': typeof AuthenticatedPermitsPermitIdIndexRoute
  '/reports/$id/': typeof AuthenticatedReportsIdIndexRoute
  '/sample-results/$resultId/': typeof AuthenticatedSampleResultsResultIdIndexRoute
  '/sampling-events/$eventId/': typeof AuthenticatedSamplingEventsEventIdIndexRoute
  '/tasks/$id/': typeof AuthenticatedTasksIdIndexRoute
  '/temporary-devices/$id/': typeof AuthenticatedTemporaryDevicesIdIndexRoute
  '/test-entry/$assignmentId/': typeof AuthenticatedTestEntryAssignmentIdIndexRoute
  '/test-kits/$id/': typeof AuthenticatedTestKitsIdIndexRoute
  '/testers/$id/': typeof AuthenticatedTestersIdIndexRoute
  '/testing-companies/$id/': typeof AuthenticatedTestingCompaniesIdIndexRoute
  '/org/settings/groups/new': typeof AuthenticatedOrgSettingsGroupsNewRoute
  '/org/settings/members/$memberId': typeof AuthenticatedOrgSettingsMembersMemberIdRoute
  '/test-program/schedules/$id/edit': typeof AuthenticatedTestProgramSchedulesIdEditRoute
  '/test-program/templates/$id/builder': typeof AuthenticatedTestProgramTemplatesIdBuilderRoute
  '/notices/rules/$ladderId/': typeof AuthenticatedNoticesRulesLadderIdIndexRoute
  '/notices/templates/$id/': typeof AuthenticatedNoticesTemplatesIdIndexRoute
  '/reports/dashboards/$id/': typeof AuthenticatedReportsDashboardsIdIndexRoute
  '/test-activity/assignments/$id/': typeof AuthenticatedTestActivityAssignmentsIdIndexRoute
  '/test-activity/change-requests/$setId/': typeof AuthenticatedTestActivityChangeRequestsSetIdIndexRoute
  '/test-activity/submissions/$id/': typeof AuthenticatedTestActivitySubmissionsIdIndexRoute
  '/test-activity/violations/$id/': typeof AuthenticatedTestActivityViolationsIdIndexRoute
  '/test-program/templates/$id/': typeof AuthenticatedTestProgramTemplatesIdIndexRoute
  '/org/settings/groups/$groupId/edit': typeof AuthenticatedOrgSettingsGroupsGroupIdEditRoute
  '/org/settings/report-forms/$id/edit': typeof AuthenticatedOrgSettingsReportFormsIdEditRoute
  '/org/settings/groups/$groupId/': typeof AuthenticatedOrgSettingsGroupsGroupIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/select-org': typeof SelectOrgRoute
  '/signup': typeof SignupRoute
  '/accept-invite': typeof AuthenticatedAcceptInviteRoute
  '/catalog': typeof AuthenticatedCatalogRouteWithChildren
  '/categorical-standards': typeof AuthenticatedCategoricalStandardsRoute
  '/invites': typeof AuthenticatedInvitesRoute
  '/mfa-prompt': typeof AuthenticatedMfaPromptRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/dev/visual-fixture': typeof DevVisualFixtureRoute
  '/': typeof AuthenticatedIndexRoute
  '/accounts/new': typeof AuthenticatedAccountsNewRoute
  '/bulk-edits/new': typeof AuthenticatedBulkEditsNewRoute
  '/catalog/detector-meters': typeof AuthenticatedCatalogDetectorMetersRoute
  '/catalog/lookup': typeof AuthenticatedCatalogLookupRoute
  '/catalog/shutoff-valves': typeof AuthenticatedCatalogShutoffValvesRoute
  '/facilities/new': typeof AuthenticatedFacilitiesNewRoute
  '/labs/defaults': typeof AuthenticatedLabsDefaultsRoute
  '/labs/new': typeof AuthenticatedLabsNewRoute
  '/monitoring-locations/new': typeof AuthenticatedMonitoringLocationsNewRoute
  '/parameters/new': typeof AuthenticatedParametersNewRoute
  '/permits/new': typeof AuthenticatedPermitsNewRoute
  '/reports/new': typeof AuthenticatedReportsNewRoute
  '/sampling-events/new': typeof AuthenticatedSamplingEventsNewRoute
  '/sampling/calendar': typeof AuthenticatedSamplingCalendarRoute
  '/schedules/$scheduleId': typeof AuthenticatedSchedulesScheduleIdRoute
  '/schedules/new': typeof AuthenticatedSchedulesNewRoute
  '/settings/mfa': typeof AuthenticatedSettingsMfaRoute
  '/temporary-devices/new': typeof AuthenticatedTemporaryDevicesNewRoute
  '/test-entry/new': typeof AuthenticatedTestEntryNewRoute
  '/accounts': typeof AuthenticatedAccountsIndexRoute
  '/bulk-edits': typeof AuthenticatedBulkEditsIndexRoute
  '/device-installations': typeof AuthenticatedDeviceInstallationsIndexRoute
  '/documents': typeof AuthenticatedDocumentsIndexRoute
  '/exceedances': typeof AuthenticatedExceedancesIndexRoute
  '/facilities': typeof AuthenticatedFacilitiesIndexRoute
  '/labs': typeof AuthenticatedLabsIndexRoute
  '/messages': typeof AuthenticatedMessagesIndexRoute
  '/monitoring-gaps': typeof AuthenticatedMonitoringGapsIndexRoute
  '/monitoring-locations': typeof AuthenticatedMonitoringLocationsIndexRoute
  '/notices': typeof AuthenticatedNoticesIndexRoute
  '/parameters': typeof AuthenticatedParametersIndexRoute
  '/permits': typeof AuthenticatedPermitsIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/sample-results': typeof AuthenticatedSampleResultsIndexRoute
  '/sampling-events': typeof AuthenticatedSamplingEventsIndexRoute
  '/sams': typeof AuthenticatedSamsIndexRoute
  '/schedules': typeof AuthenticatedSchedulesIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/temporary-devices': typeof AuthenticatedTemporaryDevicesIndexRoute
  '/test-activity': typeof AuthenticatedTestActivityIndexRoute
  '/test-program': typeof AuthenticatedTestProgramIndexRoute
  '/testers': typeof AuthenticatedTestersIndexRoute
  '/catalog/assemblies/$id': typeof AuthenticatedCatalogAssembliesIdRoute
  '/catalog/manufacturers/$id': typeof AuthenticatedCatalogManufacturersIdRoute
  '/catalog/special-notices/$id': typeof AuthenticatedCatalogSpecialNoticesIdRoute
  '/monitoring-locations/$locationId/edit': typeof AuthenticatedMonitoringLocationsLocationIdEditRoute
  '/notices/$id/edit': typeof AuthenticatedNoticesIdEditRoute
  '/notices/rules/new': typeof AuthenticatedNoticesRulesNewRoute
  '/parameters/$parameterId/edit': typeof AuthenticatedParametersParameterIdEditRoute
  '/permits/$permitId/edit': typeof AuthenticatedPermitsPermitIdEditRoute
  '/permits/$permitId/parameters': typeof AuthenticatedPermitsPermitIdParametersRoute
  '/reports/$id/edit': typeof AuthenticatedReportsIdEditRoute
  '/reports/dashboards/new': typeof AuthenticatedReportsDashboardsNewRoute
  '/tasks/$id/edit': typeof AuthenticatedTasksIdEditRoute
  '/temporary-devices/$id/edit': typeof AuthenticatedTemporaryDevicesIdEditRoute
  '/test-activity/assignments/new': typeof AuthenticatedTestActivityAssignmentsNewRoute
  '/test-kits/$id/edit': typeof AuthenticatedTestKitsIdEditRoute
  '/test-program/schedules/new': typeof AuthenticatedTestProgramSchedulesNewRoute
  '/test-program/templates/new': typeof AuthenticatedTestProgramTemplatesNewRoute
  '/testers/access-requests/$companyId': typeof AuthenticatedTestersAccessRequestsCompanyIdRoute
  '/accounts/$id': typeof AuthenticatedAccountsIdIndexRoute
  '/backflow/out-of-compliance': typeof AuthenticatedBackflowOutOfComplianceIndexRoute
  '/bulk-edits/$runId': typeof AuthenticatedBulkEditsRunIdIndexRoute
  '/catalog/assemblies': typeof AuthenticatedCatalogAssembliesIndexRoute
  '/catalog/special-notices': typeof AuthenticatedCatalogSpecialNoticesIndexRoute
  '/device-installations/$id': typeof AuthenticatedDeviceInstallationsIdIndexRoute
  '/facilities/$facilityId': typeof AuthenticatedFacilitiesFacilityIdIndexRoute
  '/labs/$labId': typeof AuthenticatedLabsLabIdIndexRoute
  '/monitoring-locations/$locationId': typeof AuthenticatedMonitoringLocationsLocationIdIndexRoute
  '/notices/$id': typeof AuthenticatedNoticesIdIndexRoute
  '/notices/new': typeof AuthenticatedNoticesNewIndexRoute
  '/org/settings': typeof AuthenticatedOrgSettingsIndexRoute
  '/parameters/$parameterId': typeof AuthenticatedParametersParameterIdIndexRoute
  '/permits/$permitId': typeof AuthenticatedPermitsPermitIdIndexRoute
  '/reports/$id': typeof AuthenticatedReportsIdIndexRoute
  '/sample-results/$resultId': typeof AuthenticatedSampleResultsResultIdIndexRoute
  '/sampling-events/$eventId': typeof AuthenticatedSamplingEventsEventIdIndexRoute
  '/tasks/$id': typeof AuthenticatedTasksIdIndexRoute
  '/temporary-devices/$id': typeof AuthenticatedTemporaryDevicesIdIndexRoute
  '/test-entry/$assignmentId': typeof AuthenticatedTestEntryAssignmentIdIndexRoute
  '/test-kits/$id': typeof AuthenticatedTestKitsIdIndexRoute
  '/testers/$id': typeof AuthenticatedTestersIdIndexRoute
  '/testing-companies/$id': typeof AuthenticatedTestingCompaniesIdIndexRoute
  '/org/settings/groups/new': typeof AuthenticatedOrgSettingsGroupsNewRoute
  '/org/settings/members/$memberId': typeof AuthenticatedOrgSettingsMembersMemberIdRoute
  '/test-program/schedules/$id/edit': typeof AuthenticatedTestProgramSchedulesIdEditRoute
  '/test-program/templates/$id/builder': typeof AuthenticatedTestProgramTemplatesIdBuilderRoute
  '/notices/rules/$ladderId': typeof AuthenticatedNoticesRulesLadderIdIndexRoute
  '/notices/templates/$id': typeof AuthenticatedNoticesTemplatesIdIndexRoute
  '/reports/dashboards/$id': typeof AuthenticatedReportsDashboardsIdIndexRoute
  '/test-activity/assignments/$id': typeof AuthenticatedTestActivityAssignmentsIdIndexRoute
  '/test-activity/change-requests/$setId': typeof AuthenticatedTestActivityChangeRequestsSetIdIndexRoute
  '/test-activity/submissions/$id': typeof AuthenticatedTestActivitySubmissionsIdIndexRoute
  '/test-activity/violations/$id': typeof AuthenticatedTestActivityViolationsIdIndexRoute
  '/test-program/templates/$id': typeof AuthenticatedTestProgramTemplatesIdIndexRoute
  '/org/settings/groups/$groupId/edit': typeof AuthenticatedOrgSettingsGroupsGroupIdEditRoute
  '/org/settings/report-forms/$id/edit': typeof AuthenticatedOrgSettingsReportFormsIdEditRoute
  '/org/settings/groups/$groupId': typeof AuthenticatedOrgSettingsGroupsGroupIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/select-org': typeof SelectOrgRoute
  '/signup': typeof SignupRoute
  '/_authenticated/accept-invite': typeof AuthenticatedAcceptInviteRoute
  '/_authenticated/catalog': typeof AuthenticatedCatalogRouteWithChildren
  '/_authenticated/categorical-standards': typeof AuthenticatedCategoricalStandardsRoute
  '/_authenticated/invites': typeof AuthenticatedInvitesRoute
  '/_authenticated/mfa-prompt': typeof AuthenticatedMfaPromptRoute
  '/_authenticated/notices': typeof AuthenticatedNoticesRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/test-activity': typeof AuthenticatedTestActivityRouteWithChildren
  '/_authenticated/test-program': typeof AuthenticatedTestProgramRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/dev/visual-fixture': typeof DevVisualFixtureRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/accounts/new': typeof AuthenticatedAccountsNewRoute
  '/_authenticated/bulk-edits/new': typeof AuthenticatedBulkEditsNewRoute
  '/_authenticated/catalog/detector-meters': typeof AuthenticatedCatalogDetectorMetersRoute
  '/_authenticated/catalog/lookup': typeof AuthenticatedCatalogLookupRoute
  '/_authenticated/catalog/shutoff-valves': typeof AuthenticatedCatalogShutoffValvesRoute
  '/_authenticated/facilities/new': typeof AuthenticatedFacilitiesNewRoute
  '/_authenticated/labs/defaults': typeof AuthenticatedLabsDefaultsRoute
  '/_authenticated/labs/new': typeof AuthenticatedLabsNewRoute
  '/_authenticated/monitoring-locations/new': typeof AuthenticatedMonitoringLocationsNewRoute
  '/_authenticated/org/settings': typeof AuthenticatedOrgSettingsRouteWithChildren
  '/_authenticated/parameters/new': typeof AuthenticatedParametersNewRoute
  '/_authenticated/permits/new': typeof AuthenticatedPermitsNewRoute
  '/_authenticated/reports/new': typeof AuthenticatedReportsNewRoute
  '/_authenticated/sampling-events/new': typeof AuthenticatedSamplingEventsNewRoute
  '/_authenticated/sampling/calendar': typeof AuthenticatedSamplingCalendarRoute
  '/_authenticated/schedules/$scheduleId': typeof AuthenticatedSchedulesScheduleIdRoute
  '/_authenticated/schedules/new': typeof AuthenticatedSchedulesNewRoute
  '/_authenticated/settings/mfa': typeof AuthenticatedSettingsMfaRoute
  '/_authenticated/temporary-devices/new': typeof AuthenticatedTemporaryDevicesNewRoute
  '/_authenticated/test-entry/new': typeof AuthenticatedTestEntryNewRoute
  '/_authenticated/accounts/': typeof AuthenticatedAccountsIndexRoute
  '/_authenticated/bulk-edits/': typeof AuthenticatedBulkEditsIndexRoute
  '/_authenticated/device-installations/': typeof AuthenticatedDeviceInstallationsIndexRoute
  '/_authenticated/documents/': typeof AuthenticatedDocumentsIndexRoute
  '/_authenticated/exceedances/': typeof AuthenticatedExceedancesIndexRoute
  '/_authenticated/facilities/': typeof AuthenticatedFacilitiesIndexRoute
  '/_authenticated/labs/': typeof AuthenticatedLabsIndexRoute
  '/_authenticated/messages/': typeof AuthenticatedMessagesIndexRoute
  '/_authenticated/monitoring-gaps/': typeof AuthenticatedMonitoringGapsIndexRoute
  '/_authenticated/monitoring-locations/': typeof AuthenticatedMonitoringLocationsIndexRoute
  '/_authenticated/notices/': typeof AuthenticatedNoticesIndexRoute
  '/_authenticated/parameters/': typeof AuthenticatedParametersIndexRoute
  '/_authenticated/permits/': typeof AuthenticatedPermitsIndexRoute
  '/_authenticated/reports/': typeof AuthenticatedReportsIndexRoute
  '/_authenticated/sample-results/': typeof AuthenticatedSampleResultsIndexRoute
  '/_authenticated/sampling-events/': typeof AuthenticatedSamplingEventsIndexRoute
  '/_authenticated/sams/': typeof AuthenticatedSamsIndexRoute
  '/_authenticated/schedules/': typeof AuthenticatedSchedulesIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/temporary-devices/': typeof AuthenticatedTemporaryDevicesIndexRoute
  '/_authenticated/test-activity/': typeof AuthenticatedTestActivityIndexRoute
  '/_authenticated/test-program/': typeof AuthenticatedTestProgramIndexRoute
  '/_authenticated/testers/': typeof AuthenticatedTestersIndexRoute
  '/_authenticated/catalog/assemblies/$id': typeof AuthenticatedCatalogAssembliesIdRoute
  '/_authenticated/catalog/manufacturers/$id': typeof AuthenticatedCatalogManufacturersIdRoute
  '/_authenticated/catalog/special-notices/$id': typeof AuthenticatedCatalogSpecialNoticesIdRoute
  '/_authenticated/monitoring-locations/$locationId/edit': typeof AuthenticatedMonitoringLocationsLocationIdEditRoute
  '/_authenticated/notices/$id/edit': typeof AuthenticatedNoticesIdEditRoute
  '/_authenticated/notices/rules/new': typeof AuthenticatedNoticesRulesNewRoute
  '/_authenticated/parameters/$parameterId/edit': typeof AuthenticatedParametersParameterIdEditRoute
  '/_authenticated/permits/$permitId/edit': typeof AuthenticatedPermitsPermitIdEditRoute
  '/_authenticated/permits/$permitId/parameters': typeof AuthenticatedPermitsPermitIdParametersRoute
  '/_authenticated/reports/$id/edit': typeof AuthenticatedReportsIdEditRoute
  '/_authenticated/reports/dashboards/new': typeof AuthenticatedReportsDashboardsNewRoute
  '/_authenticated/tasks/$id/edit': typeof AuthenticatedTasksIdEditRoute
  '/_authenticated/temporary-devices/$id/edit': typeof AuthenticatedTemporaryDevicesIdEditRoute
  '/_authenticated/test-activity/assignments/new': typeof AuthenticatedTestActivityAssignmentsNewRoute
  '/_authenticated/test-kits/$id/edit': typeof AuthenticatedTestKitsIdEditRoute
  '/_authenticated/test-program/schedules/new': typeof AuthenticatedTestProgramSchedulesNewRoute
  '/_authenticated/test-program/templates/new': typeof AuthenticatedTestProgramTemplatesNewRoute
  '/_authenticated/testers/access-requests/$companyId': typeof AuthenticatedTestersAccessRequestsCompanyIdRoute
  '/_authenticated/accounts/$id/': typeof AuthenticatedAccountsIdIndexRoute
  '/_authenticated/backflow/out-of-compliance/': typeof AuthenticatedBackflowOutOfComplianceIndexRoute
  '/_authenticated/bulk-edits/$runId/': typeof AuthenticatedBulkEditsRunIdIndexRoute
  '/_authenticated/catalog/assemblies/': typeof AuthenticatedCatalogAssembliesIndexRoute
  '/_authenticated/catalog/special-notices/': typeof AuthenticatedCatalogSpecialNoticesIndexRoute
  '/_authenticated/device-installations/$id/': typeof AuthenticatedDeviceInstallationsIdIndexRoute
  '/_authenticated/facilities/$facilityId/': typeof AuthenticatedFacilitiesFacilityIdIndexRoute
  '/_authenticated/labs/$labId/': typeof AuthenticatedLabsLabIdIndexRoute
  '/_authenticated/monitoring-locations/$locationId/': typeof AuthenticatedMonitoringLocationsLocationIdIndexRoute
  '/_authenticated/notices/$id/': typeof AuthenticatedNoticesIdIndexRoute
  '/_authenticated/notices/new/': typeof AuthenticatedNoticesNewIndexRoute
  '/_authenticated/org/settings/': typeof AuthenticatedOrgSettingsIndexRoute
  '/_authenticated/parameters/$parameterId/': typeof AuthenticatedParametersParameterIdIndexRoute
  '/_authenticated/permits/$permitId/': typeof AuthenticatedPermitsPermitIdIndexRoute
  '/_authenticated/reports/$id/': typeof AuthenticatedReportsIdIndexRoute
  '/_authenticated/sample-results/$resultId/': typeof AuthenticatedSampleResultsResultIdIndexRoute
  '/_authenticated/sampling-events/$eventId/': typeof AuthenticatedSamplingEventsEventIdIndexRoute
  '/_authenticated/tasks/$id/': typeof AuthenticatedTasksIdIndexRoute
  '/_authenticated/temporary-devices/$id/': typeof AuthenticatedTemporaryDevicesIdIndexRoute
  '/_authenticated/test-entry/$assignmentId/': typeof AuthenticatedTestEntryAssignmentIdIndexRoute
  '/_authenticated/test-kits/$id/': typeof AuthenticatedTestKitsIdIndexRoute
  '/_authenticated/testers/$id/': typeof AuthenticatedTestersIdIndexRoute
  '/_authenticated/testing-companies/$id/': typeof AuthenticatedTestingCompaniesIdIndexRoute
  '/_authenticated/org/settings/groups/new': typeof AuthenticatedOrgSettingsGroupsNewRoute
  '/_authenticated/org/settings/members/$memberId': typeof AuthenticatedOrgSettingsMembersMemberIdRoute
  '/_authenticated/test-program/schedules/$id/edit': typeof AuthenticatedTestProgramSchedulesIdEditRoute
  '/_authenticated/test-program/templates/$id/builder': typeof AuthenticatedTestProgramTemplatesIdBuilderRoute
  '/_authenticated/notices/rules/$ladderId/': typeof AuthenticatedNoticesRulesLadderIdIndexRoute
  '/_authenticated/notices/templates/$id/': typeof AuthenticatedNoticesTemplatesIdIndexRoute
  '/_authenticated/reports/dashboards/$id/': typeof AuthenticatedReportsDashboardsIdIndexRoute
  '/_authenticated/test-activity/assignments/$id/': typeof AuthenticatedTestActivityAssignmentsIdIndexRoute
  '/_authenticated/test-activity/change-requests/$setId/': typeof AuthenticatedTestActivityChangeRequestsSetIdIndexRoute
  '/_authenticated/test-activity/submissions/$id/': typeof AuthenticatedTestActivitySubmissionsIdIndexRoute
  '/_authenticated/test-activity/violations/$id/': typeof AuthenticatedTestActivityViolationsIdIndexRoute
  '/_authenticated/test-program/templates/$id/': typeof AuthenticatedTestProgramTemplatesIdIndexRoute
  '/_authenticated/org/settings/groups/$groupId/edit': typeof AuthenticatedOrgSettingsGroupsGroupIdEditRoute
  '/_authenticated/org/settings/report-forms/$id/edit': typeof AuthenticatedOrgSettingsReportFormsIdEditRoute
  '/_authenticated/org/settings/groups/$groupId/': typeof AuthenticatedOrgSettingsGroupsGroupIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/select-org'
    | '/signup'
    | '/accept-invite'
    | '/catalog'
    | '/categorical-standards'
    | '/invites'
    | '/mfa-prompt'
    | '/notices'
    | '/settings'
    | '/test-activity'
    | '/test-program'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/verify-email'
    | '/dev/visual-fixture'
    | '/accounts/new'
    | '/bulk-edits/new'
    | '/catalog/detector-meters'
    | '/catalog/lookup'
    | '/catalog/shutoff-valves'
    | '/facilities/new'
    | '/labs/defaults'
    | '/labs/new'
    | '/monitoring-locations/new'
    | '/org/settings'
    | '/parameters/new'
    | '/permits/new'
    | '/reports/new'
    | '/sampling-events/new'
    | '/sampling/calendar'
    | '/schedules/$scheduleId'
    | '/schedules/new'
    | '/settings/mfa'
    | '/temporary-devices/new'
    | '/test-entry/new'
    | '/accounts/'
    | '/bulk-edits/'
    | '/device-installations/'
    | '/documents/'
    | '/exceedances/'
    | '/facilities/'
    | '/labs/'
    | '/messages/'
    | '/monitoring-gaps/'
    | '/monitoring-locations/'
    | '/notices/'
    | '/parameters/'
    | '/permits/'
    | '/reports/'
    | '/sample-results/'
    | '/sampling-events/'
    | '/sams/'
    | '/schedules/'
    | '/settings/'
    | '/tasks/'
    | '/temporary-devices/'
    | '/test-activity/'
    | '/test-program/'
    | '/testers/'
    | '/catalog/assemblies/$id'
    | '/catalog/manufacturers/$id'
    | '/catalog/special-notices/$id'
    | '/monitoring-locations/$locationId/edit'
    | '/notices/$id/edit'
    | '/notices/rules/new'
    | '/parameters/$parameterId/edit'
    | '/permits/$permitId/edit'
    | '/permits/$permitId/parameters'
    | '/reports/$id/edit'
    | '/reports/dashboards/new'
    | '/tasks/$id/edit'
    | '/temporary-devices/$id/edit'
    | '/test-activity/assignments/new'
    | '/test-kits/$id/edit'
    | '/test-program/schedules/new'
    | '/test-program/templates/new'
    | '/testers/access-requests/$companyId'
    | '/accounts/$id/'
    | '/backflow/out-of-compliance/'
    | '/bulk-edits/$runId/'
    | '/catalog/assemblies/'
    | '/catalog/special-notices/'
    | '/device-installations/$id/'
    | '/facilities/$facilityId/'
    | '/labs/$labId/'
    | '/monitoring-locations/$locationId/'
    | '/notices/$id/'
    | '/notices/new/'
    | '/org/settings/'
    | '/parameters/$parameterId/'
    | '/permits/$permitId/'
    | '/reports/$id/'
    | '/sample-results/$resultId/'
    | '/sampling-events/$eventId/'
    | '/tasks/$id/'
    | '/temporary-devices/$id/'
    | '/test-entry/$assignmentId/'
    | '/test-kits/$id/'
    | '/testers/$id/'
    | '/testing-companies/$id/'
    | '/org/settings/groups/new'
    | '/org/settings/members/$memberId'
    | '/test-program/schedules/$id/edit'
    | '/test-program/templates/$id/builder'
    | '/notices/rules/$ladderId/'
    | '/notices/templates/$id/'
    | '/reports/dashboards/$id/'
    | '/test-activity/assignments/$id/'
    | '/test-activity/change-requests/$setId/'
    | '/test-activity/submissions/$id/'
    | '/test-activity/violations/$id/'
    | '/test-program/templates/$id/'
    | '/org/settings/groups/$groupId/edit'
    | '/org/settings/report-forms/$id/edit'
    | '/org/settings/groups/$groupId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/select-org'
    | '/signup'
    | '/accept-invite'
    | '/catalog'
    | '/categorical-standards'
    | '/invites'
    | '/mfa-prompt'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/verify-email'
    | '/dev/visual-fixture'
    | '/'
    | '/accounts/new'
    | '/bulk-edits/new'
    | '/catalog/detector-meters'
    | '/catalog/lookup'
    | '/catalog/shutoff-valves'
    | '/facilities/new'
    | '/labs/defaults'
    | '/labs/new'
    | '/monitoring-locations/new'
    | '/parameters/new'
    | '/permits/new'
    | '/reports/new'
    | '/sampling-events/new'
    | '/sampling/calendar'
    | '/schedules/$scheduleId'
    | '/schedules/new'
    | '/settings/mfa'
    | '/temporary-devices/new'
    | '/test-entry/new'
    | '/accounts'
    | '/bulk-edits'
    | '/device-installations'
    | '/documents'
    | '/exceedances'
    | '/facilities'
    | '/labs'
    | '/messages'
    | '/monitoring-gaps'
    | '/monitoring-locations'
    | '/notices'
    | '/parameters'
    | '/permits'
    | '/reports'
    | '/sample-results'
    | '/sampling-events'
    | '/sams'
    | '/schedules'
    | '/settings'
    | '/tasks'
    | '/temporary-devices'
    | '/test-activity'
    | '/test-program'
    | '/testers'
    | '/catalog/assemblies/$id'
    | '/catalog/manufacturers/$id'
    | '/catalog/special-notices/$id'
    | '/monitoring-locations/$locationId/edit'
    | '/notices/$id/edit'
    | '/notices/rules/new'
    | '/parameters/$parameterId/edit'
    | '/permits/$permitId/edit'
    | '/permits/$permitId/parameters'
    | '/reports/$id/edit'
    | '/reports/dashboards/new'
    | '/tasks/$id/edit'
    | '/temporary-devices/$id/edit'
    | '/test-activity/assignments/new'
    | '/test-kits/$id/edit'
    | '/test-program/schedules/new'
    | '/test-program/templates/new'
    | '/testers/access-requests/$companyId'
    | '/accounts/$id'
    | '/backflow/out-of-compliance'
    | '/bulk-edits/$runId'
    | '/catalog/assemblies'
    | '/catalog/special-notices'
    | '/device-installations/$id'
    | '/facilities/$facilityId'
    | '/labs/$labId'
    | '/monitoring-locations/$locationId'
    | '/notices/$id'
    | '/notices/new'
    | '/org/settings'
    | '/parameters/$parameterId'
    | '/permits/$permitId'
    | '/reports/$id'
    | '/sample-results/$resultId'
    | '/sampling-events/$eventId'
    | '/tasks/$id'
    | '/temporary-devices/$id'
    | '/test-entry/$assignmentId'
    | '/test-kits/$id'
    | '/testers/$id'
    | '/testing-companies/$id'
    | '/org/settings/groups/new'
    | '/org/settings/members/$memberId'
    | '/test-program/schedules/$id/edit'
    | '/test-program/templates/$id/builder'
    | '/notices/rules/$ladderId'
    | '/notices/templates/$id'
    | '/reports/dashboards/$id'
    | '/test-activity/assignments/$id'
    | '/test-activity/change-requests/$setId'
    | '/test-activity/submissions/$id'
    | '/test-activity/violations/$id'
    | '/test-program/templates/$id'
    | '/org/settings/groups/$groupId/edit'
    | '/org/settings/report-forms/$id/edit'
    | '/org/settings/groups/$groupId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/select-org'
    | '/signup'
    | '/_authenticated/accept-invite'
    | '/_authenticated/catalog'
    | '/_authenticated/categorical-standards'
    | '/_authenticated/invites'
    | '/_authenticated/mfa-prompt'
    | '/_authenticated/notices'
    | '/_authenticated/settings'
    | '/_authenticated/test-activity'
    | '/_authenticated/test-program'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/verify-email'
    | '/dev/visual-fixture'
    | '/_authenticated/'
    | '/_authenticated/accounts/new'
    | '/_authenticated/bulk-edits/new'
    | '/_authenticated/catalog/detector-meters'
    | '/_authenticated/catalog/lookup'
    | '/_authenticated/catalog/shutoff-valves'
    | '/_authenticated/facilities/new'
    | '/_authenticated/labs/defaults'
    | '/_authenticated/labs/new'
    | '/_authenticated/monitoring-locations/new'
    | '/_authenticated/org/settings'
    | '/_authenticated/parameters/new'
    | '/_authenticated/permits/new'
    | '/_authenticated/reports/new'
    | '/_authenticated/sampling-events/new'
    | '/_authenticated/sampling/calendar'
    | '/_authenticated/schedules/$scheduleId'
    | '/_authenticated/schedules/new'
    | '/_authenticated/settings/mfa'
    | '/_authenticated/temporary-devices/new'
    | '/_authenticated/test-entry/new'
    | '/_authenticated/accounts/'
    | '/_authenticated/bulk-edits/'
    | '/_authenticated/device-installations/'
    | '/_authenticated/documents/'
    | '/_authenticated/exceedances/'
    | '/_authenticated/facilities/'
    | '/_authenticated/labs/'
    | '/_authenticated/messages/'
    | '/_authenticated/monitoring-gaps/'
    | '/_authenticated/monitoring-locations/'
    | '/_authenticated/notices/'
    | '/_authenticated/parameters/'
    | '/_authenticated/permits/'
    | '/_authenticated/reports/'
    | '/_authenticated/sample-results/'
    | '/_authenticated/sampling-events/'
    | '/_authenticated/sams/'
    | '/_authenticated/schedules/'
    | '/_authenticated/settings/'
    | '/_authenticated/tasks/'
    | '/_authenticated/temporary-devices/'
    | '/_authenticated/test-activity/'
    | '/_authenticated/test-program/'
    | '/_authenticated/testers/'
    | '/_authenticated/catalog/assemblies/$id'
    | '/_authenticated/catalog/manufacturers/$id'
    | '/_authenticated/catalog/special-notices/$id'
    | '/_authenticated/monitoring-locations/$locationId/edit'
    | '/_authenticated/notices/$id/edit'
    | '/_authenticated/notices/rules/new'
    | '/_authenticated/parameters/$parameterId/edit'
    | '/_authenticated/permits/$permitId/edit'
    | '/_authenticated/permits/$permitId/parameters'
    | '/_authenticated/reports/$id/edit'
    | '/_authenticated/reports/dashboards/new'
    | '/_authenticated/tasks/$id/edit'
    | '/_authenticated/temporary-devices/$id/edit'
    | '/_authenticated/test-activity/assignments/new'
    | '/_authenticated/test-kits/$id/edit'
    | '/_authenticated/test-program/schedules/new'
    | '/_authenticated/test-program/templates/new'
    | '/_authenticated/testers/access-requests/$companyId'
    | '/_authenticated/accounts/$id/'
    | '/_authenticated/backflow/out-of-compliance/'
    | '/_authenticated/bulk-edits/$runId/'
    | '/_authenticated/catalog/assemblies/'
    | '/_authenticated/catalog/special-notices/'
    | '/_authenticated/device-installations/$id/'
    | '/_authenticated/facilities/$facilityId/'
    | '/_authenticated/labs/$labId/'
    | '/_authenticated/monitoring-locations/$locationId/'
    | '/_authenticated/notices/$id/'
    | '/_authenticated/notices/new/'
    | '/_authenticated/org/settings/'
    | '/_authenticated/parameters/$parameterId/'
    | '/_authenticated/permits/$permitId/'
    | '/_authenticated/reports/$id/'
    | '/_authenticated/sample-results/$resultId/'
    | '/_authenticated/sampling-events/$eventId/'
    | '/_authenticated/tasks/$id/'
    | '/_authenticated/temporary-devices/$id/'
    | '/_authenticated/test-entry/$assignmentId/'
    | '/_authenticated/test-kits/$id/'
    | '/_authenticated/testers/$id/'
    | '/_authenticated/testing-companies/$id/'
    | '/_authenticated/org/settings/groups/new'
    | '/_authenticated/org/settings/members/$memberId'
    | '/_authenticated/test-program/schedules/$id/edit'
    | '/_authenticated/test-program/templates/$id/builder'
    | '/_authenticated/notices/rules/$ladderId/'
    | '/_authenticated/notices/templates/$id/'
    | '/_authenticated/reports/dashboards/$id/'
    | '/_authenticated/test-activity/assignments/$id/'
    | '/_authenticated/test-activity/change-requests/$setId/'
    | '/_authenticated/test-activity/submissions/$id/'
    | '/_authenticated/test-activity/violations/$id/'
    | '/_authenticated/test-program/templates/$id/'
    | '/_authenticated/org/settings/groups/$groupId/edit'
    | '/_authenticated/org/settings/report-forms/$id/edit'
    | '/_authenticated/org/settings/groups/$groupId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  SelectOrgRoute: typeof SelectOrgRoute
  SignupRoute: typeof SignupRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
  DevVisualFixtureRoute: typeof DevVisualFixtureRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/select-org': {
      id: '/select-org'
      path: '/select-org'
      fullPath: '/select-org'
      preLoaderRoute: typeof SelectOrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/dev/visual-fixture': {
      id: '/dev/visual-fixture'
      path: '/dev/visual-fixture'
      fullPath: '/dev/visual-fixture'
      preLoaderRoute: typeof DevVisualFixtureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify-email': {
      id: '/auth/verify-email'
      path: '/auth/verify-email'
      fullPath: '/auth/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/test-program': {
      id: '/_authenticated/test-program'
      path: '/test-program'
      fullPath: '/test-program'
      preLoaderRoute: typeof AuthenticatedTestProgramRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/test-activity': {
      id: '/_authenticated/test-activity'
      path: '/test-activity'
      fullPath: '/test-activity'
      preLoaderRoute: typeof AuthenticatedTestActivityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notices': {
      id: '/_authenticated/notices'
      path: '/notices'
      fullPath: '/notices'
      preLoaderRoute: typeof AuthenticatedNoticesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mfa-prompt': {
      id: '/_authenticated/mfa-prompt'
      path: '/mfa-prompt'
      fullPath: '/mfa-prompt'
      preLoaderRoute: typeof AuthenticatedMfaPromptRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invites': {
      id: '/_authenticated/invites'
      path: '/invites'
      fullPath: '/invites'
      preLoaderRoute: typeof AuthenticatedInvitesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/categorical-standards': {
      id: '/_authenticated/categorical-standards'
      path: '/categorical-standards'
      fullPath: '/categorical-standards'
      preLoaderRoute: typeof AuthenticatedCategoricalStandardsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/catalog': {
      id: '/_authenticated/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof AuthenticatedCatalogRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/accept-invite': {
      id: '/_authenticated/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AuthenticatedAcceptInviteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/testers/': {
      id: '/_authenticated/testers/'
      path: '/testers'
      fullPath: '/testers/'
      preLoaderRoute: typeof AuthenticatedTestersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/test-program/': {
      id: '/_authenticated/test-program/'
      path: '/'
      fullPath: '/test-program/'
      preLoaderRoute: typeof AuthenticatedTestProgramIndexRouteImport
      parentRoute: typeof AuthenticatedTestProgramRoute
    }
    '/_authenticated/test-activity/': {
      id: '/_authenticated/test-activity/'
      path: '/'
      fullPath: '/test-activity/'
      preLoaderRoute: typeof AuthenticatedTestActivityIndexRouteImport
      parentRoute: typeof AuthenticatedTestActivityRoute
    }
    '/_authenticated/temporary-devices/': {
      id: '/_authenticated/temporary-devices/'
      path: '/temporary-devices'
      fullPath: '/temporary-devices/'
      preLoaderRoute: typeof AuthenticatedTemporaryDevicesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/schedules/': {
      id: '/_authenticated/schedules/'
      path: '/schedules'
      fullPath: '/schedules/'
      preLoaderRoute: typeof AuthenticatedSchedulesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sams/': {
      id: '/_authenticated/sams/'
      path: '/sams'
      fullPath: '/sams/'
      preLoaderRoute: typeof AuthenticatedSamsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sampling-events/': {
      id: '/_authenticated/sampling-events/'
      path: '/sampling-events'
      fullPath: '/sampling-events/'
      preLoaderRoute: typeof AuthenticatedSamplingEventsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sample-results/': {
      id: '/_authenticated/sample-results/'
      path: '/sample-results'
      fullPath: '/sample-results/'
      preLoaderRoute: typeof AuthenticatedSampleResultsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/': {
      id: '/_authenticated/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/permits/': {
      id: '/_authenticated/permits/'
      path: '/permits'
      fullPath: '/permits/'
      preLoaderRoute: typeof AuthenticatedPermitsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/parameters/': {
      id: '/_authenticated/parameters/'
      path: '/parameters'
      fullPath: '/parameters/'
      preLoaderRoute: typeof AuthenticatedParametersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notices/': {
      id: '/_authenticated/notices/'
      path: '/'
      fullPath: '/notices/'
      preLoaderRoute: typeof AuthenticatedNoticesIndexRouteImport
      parentRoute: typeof AuthenticatedNoticesRoute
    }
    '/_authenticated/monitoring-locations/': {
      id: '/_authenticated/monitoring-locations/'
      path: '/monitoring-locations'
      fullPath: '/monitoring-locations/'
      preLoaderRoute: typeof AuthenticatedMonitoringLocationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/monitoring-gaps/': {
      id: '/_authenticated/monitoring-gaps/'
      path: '/monitoring-gaps'
      fullPath: '/monitoring-gaps/'
      preLoaderRoute: typeof AuthenticatedMonitoringGapsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/messages/': {
      id: '/_authenticated/messages/'
      path: '/messages'
      fullPath: '/messages/'
      preLoaderRoute: typeof AuthenticatedMessagesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/labs/': {
      id: '/_authenticated/labs/'
      path: '/labs'
      fullPath: '/labs/'
      preLoaderRoute: typeof AuthenticatedLabsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/facilities/': {
      id: '/_authenticated/facilities/'
      path: '/facilities'
      fullPath: '/facilities/'
      preLoaderRoute: typeof AuthenticatedFacilitiesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exceedances/': {
      id: '/_authenticated/exceedances/'
      path: '/exceedances'
      fullPath: '/exceedances/'
      preLoaderRoute: typeof AuthenticatedExceedancesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/documents/': {
      id: '/_authenticated/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof AuthenticatedDocumentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/device-installations/': {
      id: '/_authenticated/device-installations/'
      path: '/device-installations'
      fullPath: '/device-installations/'
      preLoaderRoute: typeof AuthenticatedDeviceInstallationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bulk-edits/': {
      id: '/_authenticated/bulk-edits/'
      path: '/bulk-edits'
      fullPath: '/bulk-edits/'
      preLoaderRoute: typeof AuthenticatedBulkEditsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/accounts/': {
      id: '/_authenticated/accounts/'
      path: '/accounts'
      fullPath: '/accounts/'
      preLoaderRoute: typeof AuthenticatedAccountsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/test-entry/new': {
      id: '/_authenticated/test-entry/new'
      path: '/test-entry/new'
      fullPath: '/test-entry/new'
      preLoaderRoute: typeof AuthenticatedTestEntryNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/temporary-devices/new': {
      id: '/_authenticated/temporary-devices/new'
      path: '/temporary-devices/new'
      fullPath: '/temporary-devices/new'
      preLoaderRoute: typeof AuthenticatedTemporaryDevicesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/mfa': {
      id: '/_authenticated/settings/mfa'
      path: '/mfa'
      fullPath: '/settings/mfa'
      preLoaderRoute: typeof AuthenticatedSettingsMfaRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/schedules/new': {
      id: '/_authenticated/schedules/new'
      path: '/schedules/new'
      fullPath: '/schedules/new'
      preLoaderRoute: typeof AuthenticatedSchedulesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/schedules/$scheduleId': {
      id: '/_authenticated/schedules/$scheduleId'
      path: '/schedules/$scheduleId'
      fullPath: '/schedules/$scheduleId'
      preLoaderRoute: typeof AuthenticatedSchedulesScheduleIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sampling/calendar': {
      id: '/_authenticated/sampling/calendar'
      path: '/sampling/calendar'
      fullPath: '/sampling/calendar'
      preLoaderRoute: typeof AuthenticatedSamplingCalendarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sampling-events/new': {
      id: '/_authenticated/sampling-events/new'
      path: '/sampling-events/new'
      fullPath: '/sampling-events/new'
      preLoaderRoute: typeof AuthenticatedSamplingEventsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/new': {
      id: '/_authenticated/reports/new'
      path: '/reports/new'
      fullPath: '/reports/new'
      preLoaderRoute: typeof AuthenticatedReportsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/permits/new': {
      id: '/_authenticated/permits/new'
      path: '/permits/new'
      fullPath: '/permits/new'
      preLoaderRoute: typeof AuthenticatedPermitsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/parameters/new': {
      id: '/_authenticated/parameters/new'
      path: '/parameters/new'
      fullPath: '/parameters/new'
      preLoaderRoute: typeof AuthenticatedParametersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/org/settings': {
      id: '/_authenticated/org/settings'
      path: '/org/settings'
      fullPath: '/org/settings'
      preLoaderRoute: typeof AuthenticatedOrgSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/monitoring-locations/new': {
      id: '/_authenticated/monitoring-locations/new'
      path: '/monitoring-locations/new'
      fullPath: '/monitoring-locations/new'
      preLoaderRoute: typeof AuthenticatedMonitoringLocationsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/labs/new': {
      id: '/_authenticated/labs/new'
      path: '/labs/new'
      fullPath: '/labs/new'
      preLoaderRoute: typeof AuthenticatedLabsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/labs/defaults': {
      id: '/_authenticated/labs/defaults'
      path: '/labs/defaults'
      fullPath: '/labs/defaults'
      preLoaderRoute: typeof AuthenticatedLabsDefaultsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/facilities/new': {
      id: '/_authenticated/facilities/new'
      path: '/facilities/new'
      fullPath: '/facilities/new'
      preLoaderRoute: typeof AuthenticatedFacilitiesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/catalog/shutoff-valves': {
      id: '/_authenticated/catalog/shutoff-valves'
      path: '/shutoff-valves'
      fullPath: '/catalog/shutoff-valves'
      preLoaderRoute: typeof AuthenticatedCatalogShutoffValvesRouteImport
      parentRoute: typeof AuthenticatedCatalogRoute
    }
    '/_authenticated/catalog/lookup': {
      id: '/_authenticated/catalog/lookup'
      path: '/lookup'
      fullPath: '/catalog/lookup'
      preLoaderRoute: typeof AuthenticatedCatalogLookupRouteImport
      parentRoute: typeof AuthenticatedCatalogRoute
    }
    '/_authenticated/catalog/detector-meters': {
      id: '/_authenticated/catalog/detector-meters'
      path: '/detector-meters'
      fullPath: '/catalog/detector-meters'
      preLoaderRoute: typeof AuthenticatedCatalogDetectorMetersRouteImport
      parentRoute: typeof AuthenticatedCatalogRoute
    }
    '/_authenticated/bulk-edits/new': {
      id: '/_authenticated/bulk-edits/new'
      path: '/bulk-edits/new'
      fullPath: '/bulk-edits/new'
      preLoaderRoute: typeof AuthenticatedBulkEditsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/accounts/new': {
      id: '/_authenticated/accounts/new'
      path: '/accounts/new'
      fullPath: '/accounts/new'
      preLoaderRoute: typeof AuthenticatedAccountsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/testing-companies/$id/': {
      id: '/_authenticated/testing-companies/$id/'
      path: '/testing-companies/$id'
      fullPath: '/testing-companies/$id/'
      preLoaderRoute: typeof AuthenticatedTestingCompaniesIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/testers/$id/': {
      id: '/_authenticated/testers/$id/'
      path: '/testers/$id'
      fullPath: '/testers/$id/'
      preLoaderRoute: typeof AuthenticatedTestersIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/test-kits/$id/': {
      id: '/_authenticated/test-kits/$id/'
      path: '/test-kits/$id'
      fullPath: '/test-kits/$id/'
      preLoaderRoute: typeof AuthenticatedTestKitsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/test-entry/$assignmentId/': {
      id: '/_authenticated/test-entry/$assignmentId/'
      path: '/test-entry/$assignmentId'
      fullPath: '/test-entry/$assignmentId/'
      preLoaderRoute: typeof AuthenticatedTestEntryAssignmentIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/temporary-devices/$id/': {
      id: '/_authenticated/temporary-devices/$id/'
      path: '/temporary-devices/$id'
      fullPath: '/temporary-devices/$id/'
      preLoaderRoute: typeof AuthenticatedTemporaryDevicesIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/$id/': {
      id: '/_authenticated/tasks/$id/'
      path: '/tasks/$id'
      fullPath: '/tasks/$id/'
      preLoaderRoute: typeof AuthenticatedTasksIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sampling-events/$eventId/': {
      id: '/_authenticated/sampling-events/$eventId/'
      path: '/sampling-events/$eventId'
      fullPath: '/sampling-events/$eventId/'
      preLoaderRoute: typeof AuthenticatedSamplingEventsEventIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sample-results/$resultId/': {
      id: '/_authenticated/sample-results/$resultId/'
      path: '/sample-results/$resultId'
      fullPath: '/sample-results/$resultId/'
      preLoaderRoute: typeof AuthenticatedSampleResultsResultIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/$id/': {
      id: '/_authenticated/reports/$id/'
      path: '/reports/$id'
      fullPath: '/reports/$id/'
      preLoaderRoute: typeof AuthenticatedReportsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/permits/$permitId/': {
      id: '/_authenticated/permits/$permitId/'
      path: '/permits/$permitId'
      fullPath: '/permits/$permitId/'
      preLoaderRoute: typeof AuthenticatedPermitsPermitIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/parameters/$parameterId/': {
      id: '/_authenticated/parameters/$parameterId/'
      path: '/parameters/$parameterId'
      fullPath: '/parameters/$parameterId/'
      preLoaderRoute: typeof AuthenticatedParametersParameterIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/org/settings/': {
      id: '/_authenticated/org/settings/'
      path: '/'
      fullPath: '/org/settings/'
      preLoaderRoute: typeof AuthenticatedOrgSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSettingsRoute
    }
    '/_authenticated/notices/new/': {
      id: '/_authenticated/notices/new/'
      path: '/new'
      fullPath: '/notices/new/'
      preLoaderRoute: typeof AuthenticatedNoticesNewIndexRouteImport
      parentRoute: typeof AuthenticatedNoticesRoute
    }
    '/_authenticated/notices/$id/': {
      id: '/_authenticated/notices/$id/'
      path: '/$id'
      fullPath: '/notices/$id/'
      preLoaderRoute: typeof AuthenticatedNoticesIdIndexRouteImport
      parentRoute: typeof AuthenticatedNoticesRoute
    }
    '/_authenticated/monitoring-locations/$locationId/': {
      id: '/_authenticated/monitoring-locations/$locationId/'
      path: '/monitoring-locations/$locationId'
      fullPath: '/monitoring-locations/$locationId/'
      preLoaderRoute: typeof AuthenticatedMonitoringLocationsLocationIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/labs/$labId/': {
      id: '/_authenticated/labs/$labId/'
      path: '/labs/$labId'
      fullPath: '/labs/$labId/'
      preLoaderRoute: typeof AuthenticatedLabsLabIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/facilities/$facilityId/': {
      id: '/_authenticated/facilities/$facilityId/'
      path: '/facilities/$facilityId'
      fullPath: '/facilities/$facilityId/'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/device-installations/$id/': {
      id: '/_authenticated/device-installations/$id/'
      path: '/device-installations/$id'
      fullPath: '/device-installations/$id/'
      preLoaderRoute: typeof AuthenticatedDeviceInstallationsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/catalog/special-notices/': {
      id: '/_authenticated/catalog/special-notices/'
      path: '/special-notices'
      fullPath: '/catalog/special-notices/'
      preLoaderRoute: typeof AuthenticatedCatalogSpecialNoticesIndexRouteImport
      parentRoute: typeof AuthenticatedCatalogRoute
    }
    '/_authenticated/catalog/assemblies/': {
      id: '/_authenticated/catalog/assemblies/'
      path: '/assemblies'
      fullPath: '/catalog/assemblies/'
      preLoaderRoute: typeof AuthenticatedCatalogAssembliesIndexRouteImport
      parentRoute: typeof AuthenticatedCatalogRoute
    }
    '/_authenticated/bulk-edits/$runId/': {
      id: '/_authenticated/bulk-edits/$runId/'
      path: '/bulk-edits/$runId'
      fullPath: '/bulk-edits/$runId/'
      preLoaderRoute: typeof AuthenticatedBulkEditsRunIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/backflow/out-of-compliance/': {
      id: '/_authenticated/backflow/out-of-compliance/'
      path: '/backflow/out-of-compliance'
      fullPath: '/backflow/out-of-compliance/'
      preLoaderRoute: typeof AuthenticatedBackflowOutOfComplianceIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/accounts/$id/': {
      id: '/_authenticated/accounts/$id/'
      path: '/accounts/$id'
      fullPath: '/accounts/$id/'
      preLoaderRoute: typeof AuthenticatedAccountsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/testers/access-requests/$companyId': {
      id: '/_authenticated/testers/access-requests/$companyId'
      path: '/testers/access-requests/$companyId'
      fullPath: '/testers/access-requests/$companyId'
      preLoaderRoute: typeof AuthenticatedTestersAccessRequestsCompanyIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/test-program/templates/new': {
      id: '/_authenticated/test-program/templates/new'
      path: '/templates/new'
      fullPath: '/test-program/templates/new'
      preLoaderRoute: typeof AuthenticatedTestProgramTemplatesNewRouteImport
      parentRoute: typeof AuthenticatedTestProgramRoute
    }
    '/_authenticated/test-program/schedules/new': {
      id: '/_authenticated/test-program/schedules/new'
      path: '/schedules/new'
      fullPath: '/test-program/schedules/new'
      preLoaderRoute: typeof AuthenticatedTestProgramSchedulesNewRouteImport
      parentRoute: typeof AuthenticatedTestProgramRoute
    }
    '/_authenticated/test-kits/$id/edit': {
      id: '/_authenticated/test-kits/$id/edit'
      path: '/test-kits/$id/edit'
      fullPath: '/test-kits/$id/edit'
      preLoaderRoute: typeof AuthenticatedTestKitsIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/test-activity/assignments/new': {
      id: '/_authenticated/test-activity/assignments/new'
      path: '/assignments/new'
      fullPath: '/test-activity/assignments/new'
      preLoaderRoute: typeof AuthenticatedTestActivityAssignmentsNewRouteImport
      parentRoute: typeof AuthenticatedTestActivityRoute
    }
    '/_authenticated/temporary-devices/$id/edit': {
      id: '/_authenticated/temporary-devices/$id/edit'
      path: '/temporary-devices/$id/edit'
      fullPath: '/temporary-devices/$id/edit'
      preLoaderRoute: typeof AuthenticatedTemporaryDevicesIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/$id/edit': {
      id: '/_authenticated/tasks/$id/edit'
      path: '/tasks/$id/edit'
      fullPath: '/tasks/$id/edit'
      preLoaderRoute: typeof AuthenticatedTasksIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/dashboards/new': {
      id: '/_authenticated/reports/dashboards/new'
      path: '/reports/dashboards/new'
      fullPath: '/reports/dashboards/new'
      preLoaderRoute: typeof AuthenticatedReportsDashboardsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/$id/edit': {
      id: '/_authenticated/reports/$id/edit'
      path: '/reports/$id/edit'
      fullPath: '/reports/$id/edit'
      preLoaderRoute: typeof AuthenticatedReportsIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/permits/$permitId/parameters': {
      id: '/_authenticated/permits/$permitId/parameters'
      path: '/permits/$permitId/parameters'
      fullPath: '/permits/$permitId/parameters'
      preLoaderRoute: typeof AuthenticatedPermitsPermitIdParametersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/permits/$permitId/edit': {
      id: '/_authenticated/permits/$permitId/edit'
      path: '/permits/$permitId/edit'
      fullPath: '/permits/$permitId/edit'
      preLoaderRoute: typeof AuthenticatedPermitsPermitIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/parameters/$parameterId/edit': {
      id: '/_authenticated/parameters/$parameterId/edit'
      path: '/parameters/$parameterId/edit'
      fullPath: '/parameters/$parameterId/edit'
      preLoaderRoute: typeof AuthenticatedParametersParameterIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notices/rules/new': {
      id: '/_authenticated/notices/rules/new'
      path: '/rules/new'
      fullPath: '/notices/rules/new'
      preLoaderRoute: typeof AuthenticatedNoticesRulesNewRouteImport
      parentRoute: typeof AuthenticatedNoticesRoute
    }
    '/_authenticated/notices/$id/edit': {
      id: '/_authenticated/notices/$id/edit'
      path: '/$id/edit'
      fullPath: '/notices/$id/edit'
      preLoaderRoute: typeof AuthenticatedNoticesIdEditRouteImport
      parentRoute: typeof AuthenticatedNoticesRoute
    }
    '/_authenticated/monitoring-locations/$locationId/edit': {
      id: '/_authenticated/monitoring-locations/$locationId/edit'
      path: '/monitoring-locations/$locationId/edit'
      fullPath: '/monitoring-locations/$locationId/edit'
      preLoaderRoute: typeof AuthenticatedMonitoringLocationsLocationIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/catalog/special-notices/$id': {
      id: '/_authenticated/catalog/special-notices/$id'
      path: '/special-notices/$id'
      fullPath: '/catalog/special-notices/$id'
      preLoaderRoute: typeof AuthenticatedCatalogSpecialNoticesIdRouteImport
      parentRoute: typeof AuthenticatedCatalogRoute
    }
    '/_authenticated/catalog/manufacturers/$id': {
      id: '/_authenticated/catalog/manufacturers/$id'
      path: '/manufacturers/$id'
      fullPath: '/catalog/manufacturers/$id'
      preLoaderRoute: typeof AuthenticatedCatalogManufacturersIdRouteImport
      parentRoute: typeof AuthenticatedCatalogRoute
    }
    '/_authenticated/catalog/assemblies/$id': {
      id: '/_authenticated/catalog/assemblies/$id'
      path: '/assemblies/$id'
      fullPath: '/catalog/assemblies/$id'
      preLoaderRoute: typeof AuthenticatedCatalogAssembliesIdRouteImport
      parentRoute: typeof AuthenticatedCatalogRoute
    }
    '/_authenticated/test-program/templates/$id/': {
      id: '/_authenticated/test-program/templates/$id/'
      path: '/templates/$id'
      fullPath: '/test-program/templates/$id/'
      preLoaderRoute: typeof AuthenticatedTestProgramTemplatesIdIndexRouteImport
      parentRoute: typeof AuthenticatedTestProgramRoute
    }
    '/_authenticated/test-activity/violations/$id/': {
      id: '/_authenticated/test-activity/violations/$id/'
      path: '/violations/$id'
      fullPath: '/test-activity/violations/$id/'
      preLoaderRoute: typeof AuthenticatedTestActivityViolationsIdIndexRouteImport
      parentRoute: typeof AuthenticatedTestActivityRoute
    }
    '/_authenticated/test-activity/submissions/$id/': {
      id: '/_authenticated/test-activity/submissions/$id/'
      path: '/submissions/$id'
      fullPath: '/test-activity/submissions/$id/'
      preLoaderRoute: typeof AuthenticatedTestActivitySubmissionsIdIndexRouteImport
      parentRoute: typeof AuthenticatedTestActivityRoute
    }
    '/_authenticated/test-activity/change-requests/$setId/': {
      id: '/_authenticated/test-activity/change-requests/$setId/'
      path: '/change-requests/$setId'
      fullPath: '/test-activity/change-requests/$setId/'
      preLoaderRoute: typeof AuthenticatedTestActivityChangeRequestsSetIdIndexRouteImport
      parentRoute: typeof AuthenticatedTestActivityRoute
    }
    '/_authenticated/test-activity/assignments/$id/': {
      id: '/_authenticated/test-activity/assignments/$id/'
      path: '/assignments/$id'
      fullPath: '/test-activity/assignments/$id/'
      preLoaderRoute: typeof AuthenticatedTestActivityAssignmentsIdIndexRouteImport
      parentRoute: typeof AuthenticatedTestActivityRoute
    }
    '/_authenticated/reports/dashboards/$id/': {
      id: '/_authenticated/reports/dashboards/$id/'
      path: '/reports/dashboards/$id'
      fullPath: '/reports/dashboards/$id/'
      preLoaderRoute: typeof AuthenticatedReportsDashboardsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notices/templates/$id/': {
      id: '/_authenticated/notices/templates/$id/'
      path: '/templates/$id'
      fullPath: '/notices/templates/$id/'
      preLoaderRoute: typeof AuthenticatedNoticesTemplatesIdIndexRouteImport
      parentRoute: typeof AuthenticatedNoticesRoute
    }
    '/_authenticated/notices/rules/$ladderId/': {
      id: '/_authenticated/notices/rules/$ladderId/'
      path: '/rules/$ladderId'
      fullPath: '/notices/rules/$ladderId/'
      preLoaderRoute: typeof AuthenticatedNoticesRulesLadderIdIndexRouteImport
      parentRoute: typeof AuthenticatedNoticesRoute
    }
    '/_authenticated/test-program/templates/$id/builder': {
      id: '/_authenticated/test-program/templates/$id/builder'
      path: '/templates/$id/builder'
      fullPath: '/test-program/templates/$id/builder'
      preLoaderRoute: typeof AuthenticatedTestProgramTemplatesIdBuilderRouteImport
      parentRoute: typeof AuthenticatedTestProgramRoute
    }
    '/_authenticated/test-program/schedules/$id/edit': {
      id: '/_authenticated/test-program/schedules/$id/edit'
      path: '/schedules/$id/edit'
      fullPath: '/test-program/schedules/$id/edit'
      preLoaderRoute: typeof AuthenticatedTestProgramSchedulesIdEditRouteImport
      parentRoute: typeof AuthenticatedTestProgramRoute
    }
    '/_authenticated/org/settings/members/$memberId': {
      id: '/_authenticated/org/settings/members/$memberId'
      path: '/members/$memberId'
      fullPath: '/org/settings/members/$memberId'
      preLoaderRoute: typeof AuthenticatedOrgSettingsMembersMemberIdRouteImport
      parentRoute: typeof AuthenticatedOrgSettingsRoute
    }
    '/_authenticated/org/settings/groups/new': {
      id: '/_authenticated/org/settings/groups/new'
      path: '/groups/new'
      fullPath: '/org/settings/groups/new'
      preLoaderRoute: typeof AuthenticatedOrgSettingsGroupsNewRouteImport
      parentRoute: typeof AuthenticatedOrgSettingsRoute
    }
    '/_authenticated/org/settings/groups/$groupId/': {
      id: '/_authenticated/org/settings/groups/$groupId/'
      path: '/groups/$groupId'
      fullPath: '/org/settings/groups/$groupId/'
      preLoaderRoute: typeof AuthenticatedOrgSettingsGroupsGroupIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSettingsRoute
    }
    '/_authenticated/org/settings/report-forms/$id/edit': {
      id: '/_authenticated/org/settings/report-forms/$id/edit'
      path: '/report-forms/$id/edit'
      fullPath: '/org/settings/report-forms/$id/edit'
      preLoaderRoute: typeof AuthenticatedOrgSettingsReportFormsIdEditRouteImport
      parentRoute: typeof AuthenticatedOrgSettingsRoute
    }
    '/_authenticated/org/settings/groups/$groupId/edit': {
      id: '/_authenticated/org/settings/groups/$groupId/edit'
      path: '/groups/$groupId/edit'
      fullPath: '/org/settings/groups/$groupId/edit'
      preLoaderRoute: typeof AuthenticatedOrgSettingsGroupsGroupIdEditRouteImport
      parentRoute: typeof AuthenticatedOrgSettingsRoute
    }
  }
}

interface AuthenticatedCatalogRouteChildren {
  AuthenticatedCatalogDetectorMetersRoute: typeof AuthenticatedCatalogDetectorMetersRoute
  AuthenticatedCatalogLookupRoute: typeof AuthenticatedCatalogLookupRoute
  AuthenticatedCatalogShutoffValvesRoute: typeof AuthenticatedCatalogShutoffValvesRoute
  AuthenticatedCatalogAssembliesIdRoute: typeof AuthenticatedCatalogAssembliesIdRoute
  AuthenticatedCatalogManufacturersIdRoute: typeof AuthenticatedCatalogManufacturersIdRoute
  AuthenticatedCatalogSpecialNoticesIdRoute: typeof AuthenticatedCatalogSpecialNoticesIdRoute
  AuthenticatedCatalogAssembliesIndexRoute: typeof AuthenticatedCatalogAssembliesIndexRoute
  AuthenticatedCatalogSpecialNoticesIndexRoute: typeof AuthenticatedCatalogSpecialNoticesIndexRoute
}

const AuthenticatedCatalogRouteChildren: AuthenticatedCatalogRouteChildren = {
  AuthenticatedCatalogDetectorMetersRoute:
    AuthenticatedCatalogDetectorMetersRoute,
  AuthenticatedCatalogLookupRoute: AuthenticatedCatalogLookupRoute,
  AuthenticatedCatalogShutoffValvesRoute:
    AuthenticatedCatalogShutoffValvesRoute,
  AuthenticatedCatalogAssembliesIdRoute: AuthenticatedCatalogAssembliesIdRoute,
  AuthenticatedCatalogManufacturersIdRoute:
    AuthenticatedCatalogManufacturersIdRoute,
  AuthenticatedCatalogSpecialNoticesIdRoute:
    AuthenticatedCatalogSpecialNoticesIdRoute,
  AuthenticatedCatalogAssembliesIndexRoute:
    AuthenticatedCatalogAssembliesIndexRoute,
  AuthenticatedCatalogSpecialNoticesIndexRoute:
    AuthenticatedCatalogSpecialNoticesIndexRoute,
}

const AuthenticatedCatalogRouteWithChildren =
  AuthenticatedCatalogRoute._addFileChildren(AuthenticatedCatalogRouteChildren)

interface AuthenticatedNoticesRouteChildren {
  AuthenticatedNoticesIndexRoute: typeof AuthenticatedNoticesIndexRoute
  AuthenticatedNoticesIdEditRoute: typeof AuthenticatedNoticesIdEditRoute
  AuthenticatedNoticesRulesNewRoute: typeof AuthenticatedNoticesRulesNewRoute
  AuthenticatedNoticesIdIndexRoute: typeof AuthenticatedNoticesIdIndexRoute
  AuthenticatedNoticesNewIndexRoute: typeof AuthenticatedNoticesNewIndexRoute
  AuthenticatedNoticesRulesLadderIdIndexRoute: typeof AuthenticatedNoticesRulesLadderIdIndexRoute
  AuthenticatedNoticesTemplatesIdIndexRoute: typeof AuthenticatedNoticesTemplatesIdIndexRoute
}

const AuthenticatedNoticesRouteChildren: AuthenticatedNoticesRouteChildren = {
  AuthenticatedNoticesIndexRoute: AuthenticatedNoticesIndexRoute,
  AuthenticatedNoticesIdEditRoute: AuthenticatedNoticesIdEditRoute,
  AuthenticatedNoticesRulesNewRoute: AuthenticatedNoticesRulesNewRoute,
  AuthenticatedNoticesIdIndexRoute: AuthenticatedNoticesIdIndexRoute,
  AuthenticatedNoticesNewIndexRoute: AuthenticatedNoticesNewIndexRoute,
  AuthenticatedNoticesRulesLadderIdIndexRoute:
    AuthenticatedNoticesRulesLadderIdIndexRoute,
  AuthenticatedNoticesTemplatesIdIndexRoute:
    AuthenticatedNoticesTemplatesIdIndexRoute,
}

const AuthenticatedNoticesRouteWithChildren =
  AuthenticatedNoticesRoute._addFileChildren(AuthenticatedNoticesRouteChildren)

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsMfaRoute: typeof AuthenticatedSettingsMfaRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsMfaRoute: AuthenticatedSettingsMfaRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedTestActivityRouteChildren {
  AuthenticatedTestActivityIndexRoute: typeof AuthenticatedTestActivityIndexRoute
  AuthenticatedTestActivityAssignmentsNewRoute: typeof AuthenticatedTestActivityAssignmentsNewRoute
  AuthenticatedTestActivityAssignmentsIdIndexRoute: typeof AuthenticatedTestActivityAssignmentsIdIndexRoute
  AuthenticatedTestActivityChangeRequestsSetIdIndexRoute: typeof AuthenticatedTestActivityChangeRequestsSetIdIndexRoute
  AuthenticatedTestActivitySubmissionsIdIndexRoute: typeof AuthenticatedTestActivitySubmissionsIdIndexRoute
  AuthenticatedTestActivityViolationsIdIndexRoute: typeof AuthenticatedTestActivityViolationsIdIndexRoute
}

const AuthenticatedTestActivityRouteChildren: AuthenticatedTestActivityRouteChildren =
  {
    AuthenticatedTestActivityIndexRoute: AuthenticatedTestActivityIndexRoute,
    AuthenticatedTestActivityAssignmentsNewRoute:
      AuthenticatedTestActivityAssignmentsNewRoute,
    AuthenticatedTestActivityAssignmentsIdIndexRoute:
      AuthenticatedTestActivityAssignmentsIdIndexRoute,
    AuthenticatedTestActivityChangeRequestsSetIdIndexRoute:
      AuthenticatedTestActivityChangeRequestsSetIdIndexRoute,
    AuthenticatedTestActivitySubmissionsIdIndexRoute:
      AuthenticatedTestActivitySubmissionsIdIndexRoute,
    AuthenticatedTestActivityViolationsIdIndexRoute:
      AuthenticatedTestActivityViolationsIdIndexRoute,
  }

const AuthenticatedTestActivityRouteWithChildren =
  AuthenticatedTestActivityRoute._addFileChildren(
    AuthenticatedTestActivityRouteChildren,
  )

interface AuthenticatedTestProgramRouteChildren {
  AuthenticatedTestProgramIndexRoute: typeof AuthenticatedTestProgramIndexRoute
  AuthenticatedTestProgramSchedulesNewRoute: typeof AuthenticatedTestProgramSchedulesNewRoute
  AuthenticatedTestProgramTemplatesNewRoute: typeof AuthenticatedTestProgramTemplatesNewRoute
  AuthenticatedTestProgramSchedulesIdEditRoute: typeof AuthenticatedTestProgramSchedulesIdEditRoute
  AuthenticatedTestProgramTemplatesIdBuilderRoute: typeof AuthenticatedTestProgramTemplatesIdBuilderRoute
  AuthenticatedTestProgramTemplatesIdIndexRoute: typeof AuthenticatedTestProgramTemplatesIdIndexRoute
}

const AuthenticatedTestProgramRouteChildren: AuthenticatedTestProgramRouteChildren =
  {
    AuthenticatedTestProgramIndexRoute: AuthenticatedTestProgramIndexRoute,
    AuthenticatedTestProgramSchedulesNewRoute:
      AuthenticatedTestProgramSchedulesNewRoute,
    AuthenticatedTestProgramTemplatesNewRoute:
      AuthenticatedTestProgramTemplatesNewRoute,
    AuthenticatedTestProgramSchedulesIdEditRoute:
      AuthenticatedTestProgramSchedulesIdEditRoute,
    AuthenticatedTestProgramTemplatesIdBuilderRoute:
      AuthenticatedTestProgramTemplatesIdBuilderRoute,
    AuthenticatedTestProgramTemplatesIdIndexRoute:
      AuthenticatedTestProgramTemplatesIdIndexRoute,
  }

const AuthenticatedTestProgramRouteWithChildren =
  AuthenticatedTestProgramRoute._addFileChildren(
    AuthenticatedTestProgramRouteChildren,
  )

interface AuthenticatedOrgSettingsRouteChildren {
  AuthenticatedOrgSettingsIndexRoute: typeof AuthenticatedOrgSettingsIndexRoute
  AuthenticatedOrgSettingsGroupsNewRoute: typeof AuthenticatedOrgSettingsGroupsNewRoute
  AuthenticatedOrgSettingsMembersMemberIdRoute: typeof AuthenticatedOrgSettingsMembersMemberIdRoute
  AuthenticatedOrgSettingsGroupsGroupIdEditRoute: typeof AuthenticatedOrgSettingsGroupsGroupIdEditRoute
  AuthenticatedOrgSettingsReportFormsIdEditRoute: typeof AuthenticatedOrgSettingsReportFormsIdEditRoute
  AuthenticatedOrgSettingsGroupsGroupIdIndexRoute: typeof AuthenticatedOrgSettingsGroupsGroupIdIndexRoute
}

const AuthenticatedOrgSettingsRouteChildren: AuthenticatedOrgSettingsRouteChildren =
  {
    AuthenticatedOrgSettingsIndexRoute: AuthenticatedOrgSettingsIndexRoute,
    AuthenticatedOrgSettingsGroupsNewRoute:
      AuthenticatedOrgSettingsGroupsNewRoute,
    AuthenticatedOrgSettingsMembersMemberIdRoute:
      AuthenticatedOrgSettingsMembersMemberIdRoute,
    AuthenticatedOrgSettingsGroupsGroupIdEditRoute:
      AuthenticatedOrgSettingsGroupsGroupIdEditRoute,
    AuthenticatedOrgSettingsReportFormsIdEditRoute:
      AuthenticatedOrgSettingsReportFormsIdEditRoute,
    AuthenticatedOrgSettingsGroupsGroupIdIndexRoute:
      AuthenticatedOrgSettingsGroupsGroupIdIndexRoute,
  }

const AuthenticatedOrgSettingsRouteWithChildren =
  AuthenticatedOrgSettingsRoute._addFileChildren(
    AuthenticatedOrgSettingsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAcceptInviteRoute: typeof AuthenticatedAcceptInviteRoute
  AuthenticatedCatalogRoute: typeof AuthenticatedCatalogRouteWithChildren
  AuthenticatedCategoricalStandardsRoute: typeof AuthenticatedCategoricalStandardsRoute
  AuthenticatedInvitesRoute: typeof AuthenticatedInvitesRoute
  AuthenticatedMfaPromptRoute: typeof AuthenticatedMfaPromptRoute
  AuthenticatedNoticesRoute: typeof AuthenticatedNoticesRouteWithChildren
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedTestActivityRoute: typeof AuthenticatedTestActivityRouteWithChildren
  AuthenticatedTestProgramRoute: typeof AuthenticatedTestProgramRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAccountsNewRoute: typeof AuthenticatedAccountsNewRoute
  AuthenticatedBulkEditsNewRoute: typeof AuthenticatedBulkEditsNewRoute
  AuthenticatedFacilitiesNewRoute: typeof AuthenticatedFacilitiesNewRoute
  AuthenticatedLabsDefaultsRoute: typeof AuthenticatedLabsDefaultsRoute
  AuthenticatedLabsNewRoute: typeof AuthenticatedLabsNewRoute
  AuthenticatedMonitoringLocationsNewRoute: typeof AuthenticatedMonitoringLocationsNewRoute
  AuthenticatedOrgSettingsRoute: typeof AuthenticatedOrgSettingsRouteWithChildren
  AuthenticatedParametersNewRoute: typeof AuthenticatedParametersNewRoute
  AuthenticatedPermitsNewRoute: typeof AuthenticatedPermitsNewRoute
  AuthenticatedReportsNewRoute: typeof AuthenticatedReportsNewRoute
  AuthenticatedSamplingEventsNewRoute: typeof AuthenticatedSamplingEventsNewRoute
  AuthenticatedSamplingCalendarRoute: typeof AuthenticatedSamplingCalendarRoute
  AuthenticatedSchedulesScheduleIdRoute: typeof AuthenticatedSchedulesScheduleIdRoute
  AuthenticatedSchedulesNewRoute: typeof AuthenticatedSchedulesNewRoute
  AuthenticatedTemporaryDevicesNewRoute: typeof AuthenticatedTemporaryDevicesNewRoute
  AuthenticatedTestEntryNewRoute: typeof AuthenticatedTestEntryNewRoute
  AuthenticatedAccountsIndexRoute: typeof AuthenticatedAccountsIndexRoute
  AuthenticatedBulkEditsIndexRoute: typeof AuthenticatedBulkEditsIndexRoute
  AuthenticatedDeviceInstallationsIndexRoute: typeof AuthenticatedDeviceInstallationsIndexRoute
  AuthenticatedDocumentsIndexRoute: typeof AuthenticatedDocumentsIndexRoute
  AuthenticatedExceedancesIndexRoute: typeof AuthenticatedExceedancesIndexRoute
  AuthenticatedFacilitiesIndexRoute: typeof AuthenticatedFacilitiesIndexRoute
  AuthenticatedLabsIndexRoute: typeof AuthenticatedLabsIndexRoute
  AuthenticatedMessagesIndexRoute: typeof AuthenticatedMessagesIndexRoute
  AuthenticatedMonitoringGapsIndexRoute: typeof AuthenticatedMonitoringGapsIndexRoute
  AuthenticatedMonitoringLocationsIndexRoute: typeof AuthenticatedMonitoringLocationsIndexRoute
  AuthenticatedParametersIndexRoute: typeof AuthenticatedParametersIndexRoute
  AuthenticatedPermitsIndexRoute: typeof AuthenticatedPermitsIndexRoute
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute
  AuthenticatedSampleResultsIndexRoute: typeof AuthenticatedSampleResultsIndexRoute
  AuthenticatedSamplingEventsIndexRoute: typeof AuthenticatedSamplingEventsIndexRoute
  AuthenticatedSamsIndexRoute: typeof AuthenticatedSamsIndexRoute
  AuthenticatedSchedulesIndexRoute: typeof AuthenticatedSchedulesIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedTemporaryDevicesIndexRoute: typeof AuthenticatedTemporaryDevicesIndexRoute
  AuthenticatedTestersIndexRoute: typeof AuthenticatedTestersIndexRoute
  AuthenticatedMonitoringLocationsLocationIdEditRoute: typeof AuthenticatedMonitoringLocationsLocationIdEditRoute
  AuthenticatedParametersParameterIdEditRoute: typeof AuthenticatedParametersParameterIdEditRoute
  AuthenticatedPermitsPermitIdEditRoute: typeof AuthenticatedPermitsPermitIdEditRoute
  AuthenticatedPermitsPermitIdParametersRoute: typeof AuthenticatedPermitsPermitIdParametersRoute
  AuthenticatedReportsIdEditRoute: typeof AuthenticatedReportsIdEditRoute
  AuthenticatedReportsDashboardsNewRoute: typeof AuthenticatedReportsDashboardsNewRoute
  AuthenticatedTasksIdEditRoute: typeof AuthenticatedTasksIdEditRoute
  AuthenticatedTemporaryDevicesIdEditRoute: typeof AuthenticatedTemporaryDevicesIdEditRoute
  AuthenticatedTestKitsIdEditRoute: typeof AuthenticatedTestKitsIdEditRoute
  AuthenticatedTestersAccessRequestsCompanyIdRoute: typeof AuthenticatedTestersAccessRequestsCompanyIdRoute
  AuthenticatedAccountsIdIndexRoute: typeof AuthenticatedAccountsIdIndexRoute
  AuthenticatedBackflowOutOfComplianceIndexRoute: typeof AuthenticatedBackflowOutOfComplianceIndexRoute
  AuthenticatedBulkEditsRunIdIndexRoute: typeof AuthenticatedBulkEditsRunIdIndexRoute
  AuthenticatedDeviceInstallationsIdIndexRoute: typeof AuthenticatedDeviceInstallationsIdIndexRoute
  AuthenticatedFacilitiesFacilityIdIndexRoute: typeof AuthenticatedFacilitiesFacilityIdIndexRoute
  AuthenticatedLabsLabIdIndexRoute: typeof AuthenticatedLabsLabIdIndexRoute
  AuthenticatedMonitoringLocationsLocationIdIndexRoute: typeof AuthenticatedMonitoringLocationsLocationIdIndexRoute
  AuthenticatedParametersParameterIdIndexRoute: typeof AuthenticatedParametersParameterIdIndexRoute
  AuthenticatedPermitsPermitIdIndexRoute: typeof AuthenticatedPermitsPermitIdIndexRoute
  AuthenticatedReportsIdIndexRoute: typeof AuthenticatedReportsIdIndexRoute
  AuthenticatedSampleResultsResultIdIndexRoute: typeof AuthenticatedSampleResultsResultIdIndexRoute
  AuthenticatedSamplingEventsEventIdIndexRoute: typeof AuthenticatedSamplingEventsEventIdIndexRoute
  AuthenticatedTasksIdIndexRoute: typeof AuthenticatedTasksIdIndexRoute
  AuthenticatedTemporaryDevicesIdIndexRoute: typeof AuthenticatedTemporaryDevicesIdIndexRoute
  AuthenticatedTestEntryAssignmentIdIndexRoute: typeof AuthenticatedTestEntryAssignmentIdIndexRoute
  AuthenticatedTestKitsIdIndexRoute: typeof AuthenticatedTestKitsIdIndexRoute
  AuthenticatedTestersIdIndexRoute: typeof AuthenticatedTestersIdIndexRoute
  AuthenticatedTestingCompaniesIdIndexRoute: typeof AuthenticatedTestingCompaniesIdIndexRoute
  AuthenticatedReportsDashboardsIdIndexRoute: typeof AuthenticatedReportsDashboardsIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAcceptInviteRoute: AuthenticatedAcceptInviteRoute,
  AuthenticatedCatalogRoute: AuthenticatedCatalogRouteWithChildren,
  AuthenticatedCategoricalStandardsRoute:
    AuthenticatedCategoricalStandardsRoute,
  AuthenticatedInvitesRoute: AuthenticatedInvitesRoute,
  AuthenticatedMfaPromptRoute: AuthenticatedMfaPromptRoute,
  AuthenticatedNoticesRoute: AuthenticatedNoticesRouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedTestActivityRoute: AuthenticatedTestActivityRouteWithChildren,
  AuthenticatedTestProgramRoute: AuthenticatedTestProgramRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAccountsNewRoute: AuthenticatedAccountsNewRoute,
  AuthenticatedBulkEditsNewRoute: AuthenticatedBulkEditsNewRoute,
  AuthenticatedFacilitiesNewRoute: AuthenticatedFacilitiesNewRoute,
  AuthenticatedLabsDefaultsRoute: AuthenticatedLabsDefaultsRoute,
  AuthenticatedLabsNewRoute: AuthenticatedLabsNewRoute,
  AuthenticatedMonitoringLocationsNewRoute:
    AuthenticatedMonitoringLocationsNewRoute,
  AuthenticatedOrgSettingsRoute: AuthenticatedOrgSettingsRouteWithChildren,
  AuthenticatedParametersNewRoute: AuthenticatedParametersNewRoute,
  AuthenticatedPermitsNewRoute: AuthenticatedPermitsNewRoute,
  AuthenticatedReportsNewRoute: AuthenticatedReportsNewRoute,
  AuthenticatedSamplingEventsNewRoute: AuthenticatedSamplingEventsNewRoute,
  AuthenticatedSamplingCalendarRoute: AuthenticatedSamplingCalendarRoute,
  AuthenticatedSchedulesScheduleIdRoute: AuthenticatedSchedulesScheduleIdRoute,
  AuthenticatedSchedulesNewRoute: AuthenticatedSchedulesNewRoute,
  AuthenticatedTemporaryDevicesNewRoute: AuthenticatedTemporaryDevicesNewRoute,
  AuthenticatedTestEntryNewRoute: AuthenticatedTestEntryNewRoute,
  AuthenticatedAccountsIndexRoute: AuthenticatedAccountsIndexRoute,
  AuthenticatedBulkEditsIndexRoute: AuthenticatedBulkEditsIndexRoute,
  AuthenticatedDeviceInstallationsIndexRoute:
    AuthenticatedDeviceInstallationsIndexRoute,
  AuthenticatedDocumentsIndexRoute: AuthenticatedDocumentsIndexRoute,
  AuthenticatedExceedancesIndexRoute: AuthenticatedExceedancesIndexRoute,
  AuthenticatedFacilitiesIndexRoute: AuthenticatedFacilitiesIndexRoute,
  AuthenticatedLabsIndexRoute: AuthenticatedLabsIndexRoute,
  AuthenticatedMessagesIndexRoute: AuthenticatedMessagesIndexRoute,
  AuthenticatedMonitoringGapsIndexRoute: AuthenticatedMonitoringGapsIndexRoute,
  AuthenticatedMonitoringLocationsIndexRoute:
    AuthenticatedMonitoringLocationsIndexRoute,
  AuthenticatedParametersIndexRoute: AuthenticatedParametersIndexRoute,
  AuthenticatedPermitsIndexRoute: AuthenticatedPermitsIndexRoute,
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
  AuthenticatedSampleResultsIndexRoute: AuthenticatedSampleResultsIndexRoute,
  AuthenticatedSamplingEventsIndexRoute: AuthenticatedSamplingEventsIndexRoute,
  AuthenticatedSamsIndexRoute: AuthenticatedSamsIndexRoute,
  AuthenticatedSchedulesIndexRoute: AuthenticatedSchedulesIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedTemporaryDevicesIndexRoute:
    AuthenticatedTemporaryDevicesIndexRoute,
  AuthenticatedTestersIndexRoute: AuthenticatedTestersIndexRoute,
  AuthenticatedMonitoringLocationsLocationIdEditRoute:
    AuthenticatedMonitoringLocationsLocationIdEditRoute,
  AuthenticatedParametersParameterIdEditRoute:
    AuthenticatedParametersParameterIdEditRoute,
  AuthenticatedPermitsPermitIdEditRoute: AuthenticatedPermitsPermitIdEditRoute,
  AuthenticatedPermitsPermitIdParametersRoute:
    AuthenticatedPermitsPermitIdParametersRoute,
  AuthenticatedReportsIdEditRoute: AuthenticatedReportsIdEditRoute,
  AuthenticatedReportsDashboardsNewRoute:
    AuthenticatedReportsDashboardsNewRoute,
  AuthenticatedTasksIdEditRoute: AuthenticatedTasksIdEditRoute,
  AuthenticatedTemporaryDevicesIdEditRoute:
    AuthenticatedTemporaryDevicesIdEditRoute,
  AuthenticatedTestKitsIdEditRoute: AuthenticatedTestKitsIdEditRoute,
  AuthenticatedTestersAccessRequestsCompanyIdRoute:
    AuthenticatedTestersAccessRequestsCompanyIdRoute,
  AuthenticatedAccountsIdIndexRoute: AuthenticatedAccountsIdIndexRoute,
  AuthenticatedBackflowOutOfComplianceIndexRoute:
    AuthenticatedBackflowOutOfComplianceIndexRoute,
  AuthenticatedBulkEditsRunIdIndexRoute: AuthenticatedBulkEditsRunIdIndexRoute,
  AuthenticatedDeviceInstallationsIdIndexRoute:
    AuthenticatedDeviceInstallationsIdIndexRoute,
  AuthenticatedFacilitiesFacilityIdIndexRoute:
    AuthenticatedFacilitiesFacilityIdIndexRoute,
  AuthenticatedLabsLabIdIndexRoute: AuthenticatedLabsLabIdIndexRoute,
  AuthenticatedMonitoringLocationsLocationIdIndexRoute:
    AuthenticatedMonitoringLocationsLocationIdIndexRoute,
  AuthenticatedParametersParameterIdIndexRoute:
    AuthenticatedParametersParameterIdIndexRoute,
  AuthenticatedPermitsPermitIdIndexRoute:
    AuthenticatedPermitsPermitIdIndexRoute,
  AuthenticatedReportsIdIndexRoute: AuthenticatedReportsIdIndexRoute,
  AuthenticatedSampleResultsResultIdIndexRoute:
    AuthenticatedSampleResultsResultIdIndexRoute,
  AuthenticatedSamplingEventsEventIdIndexRoute:
    AuthenticatedSamplingEventsEventIdIndexRoute,
  AuthenticatedTasksIdIndexRoute: AuthenticatedTasksIdIndexRoute,
  AuthenticatedTemporaryDevicesIdIndexRoute:
    AuthenticatedTemporaryDevicesIdIndexRoute,
  AuthenticatedTestEntryAssignmentIdIndexRoute:
    AuthenticatedTestEntryAssignmentIdIndexRoute,
  AuthenticatedTestKitsIdIndexRoute: AuthenticatedTestKitsIdIndexRoute,
  AuthenticatedTestersIdIndexRoute: AuthenticatedTestersIdIndexRoute,
  AuthenticatedTestingCompaniesIdIndexRoute:
    AuthenticatedTestingCompaniesIdIndexRoute,
  AuthenticatedReportsDashboardsIdIndexRoute:
    AuthenticatedReportsDashboardsIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  SelectOrgRoute: SelectOrgRoute,
  SignupRoute: SignupRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
  DevVisualFixtureRoute: DevVisualFixtureRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
